export const activeEntityLookUp = [
  {
    display_name_in_ui: "Ace-Hardware-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Ace Hardware Corporation",
  },
  {
    display_name_in_ui: "Ach-Food-Companies-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Ach Food Companies, Inc",
  },
  {
    display_name_in_ui: "Active-Direct",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Active Direct",
  },
  {
    display_name_in_ui: "Active-Marketplace",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Active Marketplace",
  },
  {
    display_name_in_ui: "Active-Ventures",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Active Ventures",
  },
  {
    display_name_in_ui: "Administrative",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Administrative",
  },
  {
    display_name_in_ui: "All-Market-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "All Market Inc.",
  },
  {
    display_name_in_ui: "Ally-Commercial-Finance-LLC-Bank",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Ally Commercial Finance LLC- Bank",
  },
  {
    display_name_in_ui: "Angi",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Angi",
  },
  {
    display_name_in_ui: "Applegate-Farms-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Applegate Farms, LLC",
  },
  {
    display_name_in_ui: "ARCOP-Inc-and-AFA-Service-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "ARCOP, Inc. and AFA Service Corporation",
  },
  {
    display_name_in_ui: "Astrazeneca-Pharmaceuticals-LP",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Astrazeneca Pharmaceuticals LP",
  },
  {
    display_name_in_ui: "Balanced-Health-Botanicals-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Balanced Health Botanicals, LLC",
  },
  {
    display_name_in_ui: "Belle-Tire-Industries-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Belle Tire Industries, Inc.",
  },
  {
    display_name_in_ui: "BIC-USA-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "BIC USA, Inc.",
  },
  {
    display_name_in_ui: "Biddable",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Biddable",
  },
  {
    display_name_in_ui: "Billing",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Billing",
  },
  {
    display_name_in_ui: "BroadBeam-Media-Inc",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "BroadBeam Media Inc.",
  },
  {
    display_name_in_ui: "Brother-International-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Brother International Corporation",
  },
  {
    display_name_in_ui: "Bulova-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Bulova Corporation",
  },
  {
    display_name_in_ui: "Business-Services",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Business Services",
  },
  {
    display_name_in_ui: "Business-Services-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Business Services Management",
  },
  {
    display_name_in_ui: "Cacique-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Cacique, Inc.",
  },
  {
    display_name_in_ui: "Canadian-Media",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Canadian Media",
  },
  {
    display_name_in_ui: "CARL-BUDDIG-CO",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "CARL BUDDIG & CO.",
  },
  {
    display_name_in_ui: "Cash-Business",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Cash Business",
  },
  {
    display_name_in_ui: "Choice-Hotels-International-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Choice Hotels International, Inc",
  },
  {
    display_name_in_ui: "Citizen-Watch-Company-of-America-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Citizen Watch Company of America Inc",
  },
  {
    display_name_in_ui: "Client-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Client Management",
  },
  {
    display_name_in_ui: "Colgate-Professional",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Colgate Professional",
  },
  {
    display_name_in_ui: "Colgate-Palmolive-Company",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Colgate-Palmolive Company",
  },
  {
    display_name_in_ui: "Corporate-Strategy",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Corporate Strategy",
  },
  {
    display_name_in_ui: "CORPORATE-2",
    field_name: "level004",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "CORPORATE_2",
  },
  {
    display_name_in_ui: "Credit-and-Collections",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Credit and Collections",
  },
  {
    display_name_in_ui: "CV-Sciences-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "CV Sciences Inc",
  },
  {
    display_name_in_ui: "Danone-US-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Danone US, LLC",
  },
  {
    display_name_in_ui: "Danone-Waters",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Danone Waters",
  },
  {
    display_name_in_ui: "Data-Analytics",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Data Analytics",
  },
  {
    display_name_in_ui: "Development-Corporation-For-Israel",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Development Corporation For Israel",
  },
  {
    display_name_in_ui: "Digital",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Digital",
  },
  {
    display_name_in_ui: "Digital-Seek",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Digital Seek",
  },
  {
    display_name_in_ui: "Direct-Response",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Direct Response",
  },
  {
    display_name_in_ui: "Direct-Response-Short-Form",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Direct Response Short Form",
  },
  {
    display_name_in_ui: "Dollar-Shave-Club-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Dollar Shave Club, Inc",
  },
  {
    display_name_in_ui: "DPS-Holdings-Inc-AKA-Keurig-Dr-Pepp",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "DPS Holdings, Inc. (AKA  Keurig Dr. Pepp",
  },
  {
    display_name_in_ui: "E-Commerce",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "E-Commerce",
  },
  {
    display_name_in_ui: "Edgewell-Personal-Care-Products-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Edgewell Personal Care Products, Inc",
  },
  {
    display_name_in_ui: "Elkay-Manufacturing-Company",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Elkay Manufacturing Company",
  },
  {
    display_name_in_ui: "Enotec-Imports",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Enotec Imports",
  },
  {
    display_name_in_ui: "Essity-HMS-North-America-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Essity HMS North America Inc.",
  },
  {
    display_name_in_ui: "European-Wax-Center",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "European Wax Center",
  },
  {
    display_name_in_ui: "Executive",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Executive",
  },
  {
    display_name_in_ui: "Facilities-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Facilities Management",
  },
  {
    display_name_in_ui: "Fanduel-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Fanduel Inc",
  },
  {
    display_name_in_ui: "Ferndale-Laboratories-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Ferndale Laboratories, Inc.",
  },
  {
    display_name_in_ui: "Finance",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Finance",
  },
  {
    display_name_in_ui: "Firehouse-Subs-Market-Fund-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Firehouse Subs Market Fund Inc",
  },
  {
    display_name_in_ui: "Freight",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Freight",
  },
  {
    display_name_in_ui: "Georgia-Pacific",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Georgia Pacific",
  },
  {
    display_name_in_ui: "GWR-Connecticut-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "GWR Connecticut LLC",
  },
  {
    display_name_in_ui: "Harry-Winston-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Harry Winston Inc",
  },
  {
    display_name_in_ui: "Helzberg-s-Diamond-Shops-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Helzberg's Diamond Shops, Inc",
  },
  {
    display_name_in_ui: "Henkel-Corp",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Henkel Corp",
  },
  {
    display_name_in_ui: "Hill-s-Pet-Nutrition-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Hill's Pet Nutrition Inc.",
  },
  {
    display_name_in_ui: "Hilton-Domestic-Operating-Co-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Hilton Domestic Operating Co. Inc",
  },
  {
    display_name_in_ui: "Hisense-USA-Corp",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Hisense USA Corp",
  },
  {
    display_name_in_ui: "I-G-designs-LLC-d-b-a-Fashionit",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "I&G designs, LLC d/b/a Fashionit",
  },
  {
    display_name_in_ui: "IC-3700-Flamingo-Road-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "IC 3700 Flamingo Road LLC",
  },
  {
    display_name_in_ui: "INDEPENDENCE-BEDS-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "INDEPENDENCE BEDS, LLC",
  },
  {
    display_name_in_ui: "Information-Solutions",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Information Solutions",
  },
  {
    display_name_in_ui: "International-Media",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "International Media",
  },
  {
    display_name_in_ui: "International-Media-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "International Media Management",
  },
  {
    display_name_in_ui: "International-Operations",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "International Operations",
  },
  {
    display_name_in_ui: "Keurig-Green-Mountain-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Keurig Green Mountain, Inc.",
  },
  {
    display_name_in_ui: "KIKKOMAN-Sales-U-S-A-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "KIKKOMAN Sales U.S.A.  Inc",
  },
  {
    display_name_in_ui: "Kontoor-Business",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Kontoor Business",
  },
  {
    display_name_in_ui: "Kontoor-Lee",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Kontoor/Lee",
  },
  {
    display_name_in_ui: "Kontoor-Wrangler",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Kontoor/Wrangler",
  },
  {
    display_name_in_ui: "Kroger-Company-The",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Kroger Company (The)",
  },
  {
    display_name_in_ui: "KSF-Acquisition-Corporation-Slim-Fast",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "KSF Acquisition Corporation- Slim Fast",
  },
  {
    display_name_in_ui: "Land-s-End-USA",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Land's End USA",
  },
  {
    display_name_in_ui: "Legal",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Legal",
  },
  {
    display_name_in_ui: "Local-Radio",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Local Radio",
  },
  {
    display_name_in_ui: "Local-Television",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Local Television",
  },
  {
    display_name_in_ui: "Long-John-Silvers-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Long John Silvers Inc",
  },
  {
    display_name_in_ui: "Maeda-en",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Maeda-en",
  },
  {
    display_name_in_ui: "Marketing",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Marketing",
  },
  {
    display_name_in_ui: "Mass-Minority-Inc-Serta",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Mass Minority Inc.- Serta",
  },
  {
    display_name_in_ui: "McCormick-Company-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "McCormick & Company Inc.",
  },
  {
    display_name_in_ui: "Media-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Media Management",
  },
  {
    display_name_in_ui: "Media-Partnerships",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Media Partnerships",
  },
  {
    display_name_in_ui: "Mid-Market",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Mid Market",
  },
  {
    display_name_in_ui: "National-Audio",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "National Audio",
  },
  {
    display_name_in_ui: "National-Television",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "National Television",
  },
  {
    display_name_in_ui: "Neuevu-Branding",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Neuevu Branding",
  },
  {
    display_name_in_ui: "New-Business-Development",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "New Business Development",
  },
  {
    display_name_in_ui: "Newspapers",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Newspapers",
  },
  {
    display_name_in_ui: "NON-MEDIA",
    field_name: "level004",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "NON_MEDIA",
  },
  {
    display_name_in_ui: "Novartis-Pharmaceutical-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Novartis Pharmaceutical Corporation",
  },
  {
    display_name_in_ui: "Ocean-State-Jobbers-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Ocean State Jobbers Inc.",
  },
  {
    display_name_in_ui: "Operations",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Operations",
  },
  {
    display_name_in_ui: "Out-of-Home",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Out of Home",
  },
  {
    display_name_in_ui: "Pay-for-Performance",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Pay for Performance",
  },
  {
    display_name_in_ui: "People-and-Culture",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "People and Culture",
  },
  {
    display_name_in_ui: "Perry-Ellis-International-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Perry Ellis International, Inc.",
  },
  {
    display_name_in_ui: "Philips-North-America-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Philips North America LLC",
  },
  {
    display_name_in_ui: "Placeholder-Bob-Pankuck",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - Bob Pankuck",
  },
  {
    display_name_in_ui: "Placeholder-Eric-Mollo",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - Eric Mollo",
  },
  {
    display_name_in_ui: "Placeholder-George-Blunt",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - George Blunt",
  },
  {
    display_name_in_ui: "Placeholder-Goal-to-Budget-EMollo",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - Goal to Budget-EMollo",
  },
  {
    display_name_in_ui: "Placeholder-Goal-to-Budget-GBlunt",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - Goal to Budget-GBlunt",
  },
  {
    display_name_in_ui: "Placeholder-Melissa-Keller",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - Melissa Keller",
  },
  {
    display_name_in_ui: "Placeholder-VF-Vans",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Placeholder - VF/Vans",
  },
  {
    display_name_in_ui: "Premiums",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Premiums",
  },
  {
    display_name_in_ui: "Print-Media",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Print Media",
  },
  {
    display_name_in_ui: "Print-Media-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Print Media Management",
  },
  {
    display_name_in_ui: "Printing",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Printing",
  },
  {
    display_name_in_ui: "Professional-Fighters-League",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Professional Fighters League",
  },
  {
    display_name_in_ui: "Programmatic",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Programmatic",
  },
  {
    display_name_in_ui: "Publishing",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Publishing",
  },
  {
    display_name_in_ui: "Reckitt-Benckiser-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Reckitt Benckiser LLC",
  },
  {
    display_name_in_ui: "Reckitt-Benckiser-LLC-Direct",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Reckitt Benckiser LLC â€“ Direct",
  },
  {
    display_name_in_ui: "Reckitt-Benckiser-LLC-Global",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Reckitt Benckiser LLC â€“ Global",
  },
  {
    display_name_in_ui: "Remarketing",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Remarketing",
  },
  {
    display_name_in_ui: "Robert-Bosch-Tool-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Robert Bosch Tool Corporation",
  },
  {
    display_name_in_ui: "Rust-Oleum-Corporation",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Rust-Oleum Corporation",
  },
  {
    display_name_in_ui: "Sales",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Sales",
  },
  {
    display_name_in_ui: "Sales-Management-CRM",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Sales Management / CRM",
  },
  {
    display_name_in_ui: "Salud-Natural-Entrepreneur-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Salud Natural Entrepreneur, Inc.",
  },
  {
    display_name_in_ui: "Search",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Search",
  },
  {
    display_name_in_ui: "Sensible-Rest-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Sensible Rest LLC",
  },
  {
    display_name_in_ui: "Servpro-Industries-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Servpro Industries, Inc",
  },
  {
    display_name_in_ui: "Shareholder",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Shareholder",
  },
  {
    display_name_in_ui: "Shoe-Sensation-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Shoe Sensation, Inc.",
  },
  {
    display_name_in_ui: "Sonic-Capital-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Sonic Capital LLC",
  },
  {
    display_name_in_ui: "Spectrum-Brands-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Spectrum Brands Inc.",
  },
  {
    display_name_in_ui: "Sports-and-Event-Marketing",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Sports and Event Marketing",
  },
  {
    display_name_in_ui: "Staples-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Staples, Inc",
  },
  {
    display_name_in_ui: "Strategic-Development-Group",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Strategic Development Group",
  },
  {
    display_name_in_ui: "Strategic-Partnership-Group",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Strategic Partnership Group",
  },
  {
    display_name_in_ui: "Strategy-Research-and-Planning",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Strategy, Research and Planning",
  },
  {
    display_name_in_ui: "Switchmate-Home-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Switchmate Home, LLC",
  },
  {
    display_name_in_ui: "Tata-Consumer-Products-US",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tata Consumer Products, US",
  },
  {
    display_name_in_ui: "The-Honest-Company-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "The Honest Company Inc",
  },
  {
    display_name_in_ui: "The-Pep-Boys-Manny-Moe-Jack",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "The Pep Boys â€“ Manny, Moe & Jack",
  },
  {
    display_name_in_ui: "The-Scotts-Miracle-Gro-Company",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "The Scotts Miracle-Gro Company",
  },
  {
    display_name_in_ui: "ToCAD-America-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "ToCAD America, Inc",
  },
  {
    display_name_in_ui: "Tommie-Copper",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tommie Copper",
  },
  {
    display_name_in_ui: "Tom-s-of-Maine-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tom's of Maine, Inc.",
  },
  {
    display_name_in_ui: "Tomy-International-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tomy International, Inc",
  },
  {
    display_name_in_ui: "Tophatter-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tophatter Inc",
  },
  {
    display_name_in_ui: "TOTAL-MEDIA",
    field_name: "level004",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "TOTAL_MEDIA",
  },
  {
    display_name_in_ui: "TOTAL-SALES",
    field_name: "level004",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "TOTAL_SALES",
  },
  {
    display_name_in_ui: "Tracfone-Wireless",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tracfone Wireless",
  },
  {
    display_name_in_ui: "Trade-and-Product-Development",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Trade and Product Development",
  },
  {
    display_name_in_ui: "Trade-and-Travel-Support",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Trade and Travel Support",
  },
  {
    display_name_in_ui: "Trade-Finance",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Trade Finance",
  },
  {
    display_name_in_ui: "Trade-Show-Management",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Trade Show Management",
  },
  {
    display_name_in_ui: "Travel",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Travel",
  },
  {
    display_name_in_ui: "Travel-Internet",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Travel Internet",
  },
  {
    display_name_in_ui: "Travel-Trade-Conventions",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Travel Trade Conventions",
  },
  {
    display_name_in_ui: "Tweezerman-International-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Tweezerman International, LLC",
  },
  {
    display_name_in_ui: "UK-Cinema",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "UK Cinema",
  },
  {
    display_name_in_ui: "Unwired",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "Unwired",
  },
  {
    display_name_in_ui: "Upfield",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Upfield",
  },
  {
    display_name_in_ui: "US-Auto-Parts-Network-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "US Auto Parts Network, Inc",
  },
  {
    display_name_in_ui: "Valvoline",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Valvoline",
  },
  {
    display_name_in_ui: "Valvoline-Instant-Oil-Change",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Valvoline Instant Oil Change",
  },
  {
    display_name_in_ui: "VF-Services-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "VF Services, Inc.",
  },
  {
    display_name_in_ui: "VF-Ice-Breaker",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "VF/Ice Breaker",
  },
  {
    display_name_in_ui: "VF-Kipling",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "VF/Kipling",
  },
  {
    display_name_in_ui: "VF-The-North-Face",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "VF/The North Face",
  },
  {
    display_name_in_ui: "VF-Timberland-LLC",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "VF/Timberland LLC",
  },
  {
    display_name_in_ui: "VF-Williamson-Dickie-Manufacturing-Co",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "VF/Williamson Dickie Manufacturing Co.",
  },
  {
    display_name_in_ui: "Victorias-Secret-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Victorias Secret Inc",
  },
  {
    display_name_in_ui: "Virgin-Hotels-Las-Vegas",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "Virgin Hotels Las Vegas",
  },
  {
    display_name_in_ui: "WebMD-Health-Corp",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "WebMD Health Corp",
  },
  {
    display_name_in_ui: "White-Castle-System-Inc",
    field_name: "name",
    table_name: "bpm_customer",
    schema_name: "curated",
    entity_name: "White Castle System, Inc.",
  },
  {
    display_name_in_ui: "XACTV",
    field_name: "name",
    table_name: "bpm_department",
    schema_name: "curated",
    entity_name: "XACTV",
  },
];

export const dechraEntityLookUp = [
  {
    display_name_in_ui: "113-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "113 Equine",
  },
  {
    display_name_in_ui: "360-Equine-PA",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "360 Equine, PA",
  },
  {
    display_name_in_ui: "3H-Equine-Hospital-Mobile-Vet-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "3H Equine Hospital & Mobile Vet Services",
  },
  {
    display_name_in_ui: "4S-Mobile-Equine-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "4S Mobile Equine Service",
  },
  {
    display_name_in_ui: "ABJ-Equine-Practice",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "ABJ Equine Practice",
  },
  {
    display_name_in_ui: "Activphy-75ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Activphy 75ct",
  },
  {
    display_name_in_ui: "Advanced-Veterinary-Care",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Advanced Veterinary Care",
  },
  {
    display_name_in_ui: "AF-Hauser-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "AF Hauser, Inc",
  },
  {
    display_name_in_ui: "Agro-Servicios-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Agro Servicios, Inc",
  },
  {
    display_name_in_ui: "Alamo-Pintado-Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Alamo Pintado Equine Medical Center",
  },
  {
    display_name_in_ui: "Albuquerque-Equine-Clinic-PC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Albuquerque Equine Clinic PC",
  },
  {
    display_name_in_ui: "Alexis-Torre-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Alexis Torre DVM",
  },
  {
    display_name_in_ui: "All-About-Equine-Veterinary-Services-PC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "All About Equine Veterinary Services PC",
  },
  {
    display_name_in_ui: "All-Around-Veterinary",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "All Around Veterinary",
  },
  {
    display_name_in_ui: "All-Creatures-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "All Creatures Animal Hospital",
  },
  {
    display_name_in_ui: "All-Cypress-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "All Cypress Veterinary Hospital",
  },
  {
    display_name_in_ui: "All-Seasons-Veterinary-Practice",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "All Seasons Veterinary Practice",
  },
  {
    display_name_in_ui: "Alliance-Animal-Health-Group-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Alliance Animal Health Group - US",
  },
  {
    display_name_in_ui: "Alliance-Animal-Health-Group-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Alliance Animal Health Group - US",
  },
  {
    display_name_in_ui: "Allivet",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Allivet",
  },
  {
    display_name_in_ui: "Alta-Equine-Sports-Medicine-INC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Alta Equine Sports Medicine, INC",
  },
  {
    display_name_in_ui: "Altano-North-America-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Altano North America Group",
  },
  {
    display_name_in_ui: "Altano-North-America-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Altano North America Group",
  },
  {
    display_name_in_ui: "Amatheon-Animal-Health-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Amatheon Animal Health LLC",
  },
  {
    display_name_in_ui: "Amazon-com",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Amazon.com",
  },
  {
    display_name_in_ui: "American-Veterinary-Group-AVG-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "American Veterinary Group (AVG) - US",
  },
  {
    display_name_in_ui: "American-Veterinary-Group-AVG",
    field_name: "master_corporate_group",
    table_name: "",
    schema_name: "",
    entity_name: "American Veterinary Group - AVG",
  },
  {
    display_name_in_ui: "American-Veterinary-Group-AVG-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "American Veterinary Group - AVG",
  },
  {
    display_name_in_ui: "AmeriVet-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "AmeriVet - US",
  },
  {
    display_name_in_ui: "AmeriVet-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "AmeriVet - US",
  },
  {
    display_name_in_ui: "Amie-C-Casey-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Amie C Casey DVM",
  },
  {
    display_name_in_ui: "Amoxicillin-and-Clavulanate-Potassium-for-Oral-Suspension",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Amoxicillin and Clavulanate Potassium for Oral Suspension",
  },
  {
    display_name_in_ui: "Amoxicillin-and-Clavulanate-Potassium-for-Oral-Suspension-15-ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Amoxicillin and Clavulanate Potassium for Oral Suspension 15 ml",
  },
  {
    display_name_in_ui: "Anaesthetic",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Anaesthetic",
  },
  {
    display_name_in_ui: "Andrea-Lytal-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Andrea Lytal, DVM",
  },
  {
    display_name_in_ui: "Anesthesia-Machine-Trolley-Cart",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Anesthesia Machine Trolley Cart",
  },
  {
    display_name_in_ui: "Anesthesia-Machine-Trolley-Cart-1",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Anesthesia Machine Trolley Cart",
  },
  {
    display_name_in_ui: "Animal-Care-Hospital-of-Phoenix",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Care Hospital of Phoenix",
  },
  {
    display_name_in_ui: "Animal-Clinic-West-O-Street",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Clinic West O Street",
  },
  {
    display_name_in_ui: "Animal-Health-Partners-Parent",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Health Partners - Parent",
  },
  {
    display_name_in_ui: "Animal-Health-Partners-Parent-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Health Partners - Parent",
  },
  {
    display_name_in_ui: "Animal-Hospital-of-Fayetteville",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Hospital of Fayetteville",
  },
  {
    display_name_in_ui: "Animal-Hospital-of-South-Bay",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Hospital of South Bay",
  },
  {
    display_name_in_ui: "Animal-Imaging",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Animal Imaging",
  },
  {
    display_name_in_ui: "Animax",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Animax",
  },
  {
    display_name_in_ui: "Animax-Ointment",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Animax Ointment",
  },
  {
    display_name_in_ui: "Animax-Ointment-15ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Animax Ointment 15ml",
  },
  {
    display_name_in_ui: "Animax-Ointment-30ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Animax Ointment 30ml",
  },
  {
    display_name_in_ui: "Animax-Ointment-7-5ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Animax Ointment 7.5ml",
  },
  {
    display_name_in_ui: "Anoka-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Anoka Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Anti-emetic",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Anti-emetic",
  },
  {
    display_name_in_ui: "Anti-infective",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Anti-infective",
  },
  {
    display_name_in_ui: "Ari-Kaplan-Galia-Sheinberg",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ari Kaplan / Galia Sheinberg",
  },
  {
    display_name_in_ui: "Arrow-5-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Arrow 5 Equine",
  },
  {
    display_name_in_ui: "Art-Science-Veterinary-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Art & Science Veterinary Services PLLC",
  },
  {
    display_name_in_ui: "Ascend-Equine-Mobile-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ascend Equine Mobile Sports Medicine",
  },
  {
    display_name_in_ui: "Aspen-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Aspen Veterinary Clinic",
  },
  {
    display_name_in_ui: "Aspen-Veterinary-Resources",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Aspen Veterinary Resources",
  },
  {
    display_name_in_ui: "Atopivet",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Atopivet",
  },
  {
    display_name_in_ui: "Atopivet-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Atopivet",
  },
  {
    display_name_in_ui: "Atopivet-Mousse-250-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Atopivet Mousse 250 mL",
  },
  {
    display_name_in_ui: "Atopivet-Skin-Care-Collar-13-inch",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Atopivet Skin Care Collar (13 inch)",
  },
  {
    display_name_in_ui: "Atopivet-Skin-Care-Collar-29-inch",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Atopivet Skin Care Collar (29 inch)",
  },
  {
    display_name_in_ui: "Atopivet-Spot-On",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Atopivet Spot-On",
  },
  {
    display_name_in_ui: "Auburn-VTH-Pharmacy",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Auburn VTH Pharmacy",
  },
  {
    display_name_in_ui: "AUESPP",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "AUESPP",
  },
  {
    display_name_in_ui: "Badura-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Badura Equine",
  },
  {
    display_name_in_ui: "Balanced-Care-Equine-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Balanced Care Equine LLC",
  },
  {
    display_name_in_ui: "Banfield-Corporate-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Banfield - Corporate - US",
  },
  {
    display_name_in_ui: "Bark-City-Veterinary-Specialists",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bark City Veterinary Specialists",
  },
  {
    display_name_in_ui: "Bear-River-Vet-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bear River Vet Clinic",
  },
  {
    display_name_in_ui: "Bella-Vista-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bella Vista Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Bellerose-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bellerose Animal Hospital",
  },
  {
    display_name_in_ui: "Bishop-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bishop Veterinary Hospital",
  },
  {
    display_name_in_ui: "Block-and-Bridle-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Block and Bridle Veterinary Services",
  },
  {
    display_name_in_ui: "Blue-Chip-Farms-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Blue Chip Farms LLC",
  },
  {
    display_name_in_ui: "Blue-Rabbit-Veterinary-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Blue Rabbit Veterinary, LLC",
  },
  {
    display_name_in_ui: "Blue-River-Pet-Care-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Blue River Pet Care - US",
  },
  {
    display_name_in_ui: "Blue-River-Pet-Care-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Blue River Pet Care - US",
  },
  {
    display_name_in_ui: "BluePearl-Veterinary-Partners-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "BluePearl Veterinary Partners - US",
  },
  {
    display_name_in_ui: "Bluestem-Dental-Oral-Care-Wipes-60ct-EN",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Dental Oral Care Wipes 60ct (EN)",
  },
  {
    display_name_in_ui: "Bluestem-Gel-CHICKEN-4oz-136g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Gel CHICKEN  4oz / 136g",
  },
  {
    display_name_in_ui: "Bluestem-Gel-CHICKEN-2oz-68g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Gel CHICKEN 2oz / 68g",
  },
  {
    display_name_in_ui: "Bluestem-Gel-Org-4-8oz-136g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Gel Org 4.8oz / 136g",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Care-Cat-Spray-ORIGINAL-2-oz-60ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Care Cat Spray ORIGINAL 2 oz / 60ml",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Care-Dog-Spray-MINT-4-oz-120ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Care Dog Spray MINT  4 oz / 120ml",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Care-Kit-CHICKEN-2-5oz-70g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Care Kit CHICKEN 2.5oz / 70g",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Care-Kit-VANILLA-MINT-2-5oz-70g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Care Kit VANILLA-MINT 2.5oz / 70g",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Care-Toothpaste-CHICKEN-2-5-oz-70g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Care Toothpaste CHICKEN 2.5 oz / 70g",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Care-Water-Additive-VANILLA-MINT-17-fl-oz-500ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Care Water Additive VANILLA-MINT 17 fl oz / 500ml",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Gel-ORIGINAL-2-4oz-68g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Gel ORIGINAL 2.4oz / 68g",
  },
  {
    display_name_in_ui: "Bluestem-Oral-Spray-VANILLA-MINT-2oz-60ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Oral Spray VANILLA-MINT 2oz / 60ml",
  },
  {
    display_name_in_ui: "Bluestem-Toothbrush-Finger-Brush-Kit",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Toothbrush/Finger Brush Kit",
  },
  {
    display_name_in_ui: "Bluestem-Toothbrushes-2-pack",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Toothbrushes 2-pack",
  },
  {
    display_name_in_ui: "Bluestem-Toothpaste-Combo-CHICKEN-2-5oz-70g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Toothpaste Combo CHICKEN 2.5oz / 70g",
  },
  {
    display_name_in_ui: "Bluestem-Toothpaste-VANILLA-MINT-2-5oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Toothpaste VANILLA-MINT 2.5oz",
  },
  {
    display_name_in_ui: "Bluestem-Water-Additive-CHICKEN-17oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Water Additive CHICKEN 17oz",
  },
  {
    display_name_in_ui: "Bluestem-Water-Additive-Display-ORG-2-oz-60ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Water Additive Display ORG 2 oz / 60ml",
  },
  {
    display_name_in_ui: "Bluestem-Water-Additive-ORIGINAL-17-oz-500ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Bluestem Water Additive ORIGINAL 17 oz / 500ml",
  },
  {
    display_name_in_ui: "Bomgaars",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Bomgaars",
  },
  {
    display_name_in_ui: "BOND-VET-GROUP",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "BOND VET GROUP",
  },
  {
    display_name_in_ui: "BOND-VET-GROUP-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "BOND VET GROUP",
  },
  {
    display_name_in_ui: "Brazos-Valley-Equine-Hospital-Navasota",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Brazos Valley Equine Hospital - Navasota",
  },
  {
    display_name_in_ui: "Brazos-Valley-Equine-Hospital-Salado",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Brazos Valley Equine Hospital - Salado",
  },
  {
    display_name_in_ui: "Brian-L-Wright-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Brian L. Wright, DVM",
  },
  {
    display_name_in_ui: "Bridge-Creek-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bridge Creek Equine",
  },
  {
    display_name_in_ui: "Broad-Run-Veterinary-Service-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Broad Run Veterinary Service Inc",
  },
  {
    display_name_in_ui: "Broadway-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Broadway Veterinary Hospital",
  },
  {
    display_name_in_ui: "Bur-Oak-Veterinary-Podiatry-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Bur Oak Veterinary & Podiatry Services",
  },
  {
    display_name_in_ui: "Burbank-Veterinary-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Burbank Veterinary Center",
  },
  {
    display_name_in_ui: "Burke-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Burke Equine",
  },
  {
    display_name_in_ui: "Burnett-Ranches-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Burnett Ranches, LLC",
  },
  {
    display_name_in_ui: "Butequine-60ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Butequine 60ml",
  },
  {
    display_name_in_ui: "Cactus-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cactus Veterinary Services",
  },
  {
    display_name_in_ui: "Cagemount-Block",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Cagemount Block",
  },
  {
    display_name_in_ui: "California-Pet",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "California Pet",
  },
  {
    display_name_in_ui: "Canon-Hill-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Canon Hill Veterinary Clinic",
  },
  {
    display_name_in_ui: "CareVet-LLC-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "CareVet LLC - US",
  },
  {
    display_name_in_ui: "CareVet-LLC-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "CareVet LLC - US",
  },
  {
    display_name_in_ui: "Carolina-Coastal-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Carolina Coastal Equine",
  },
  {
    display_name_in_ui: "Carprovet",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet",
  },
  {
    display_name_in_ui: "Carprovet-Caplets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets",
  },
  {
    display_name_in_ui: "Carprovet-Caplets-100mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets 100mg 180 ct",
  },
  {
    display_name_in_ui: "Carprovet-Caplets-100mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets 100mg 60 ct",
  },
  {
    display_name_in_ui: "Carprovet-Caplets-25mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets 25mg 180 ct",
  },
  {
    display_name_in_ui: "Carprovet-Caplets-25mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets 25mg 60 ct",
  },
  {
    display_name_in_ui: "Carprovet-Caplets-75mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets 75mg 180 ct",
  },
  {
    display_name_in_ui: "Carprovet-Caplets-75mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Caplets 75mg 60 ct",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-100-mg-180-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 100 mg, 180 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-100-mg-30-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 100 mg, 30 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-100-mg-60-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 100 mg, 60 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-25-mg-180-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 25 mg, 180 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-25-mg-30-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 25 mg, 30 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-25-mg-60-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 25 mg, 60 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-75-mg-180-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 75 mg, 180 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-75-mg-30-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 75 mg, 30 count",
  },
  {
    display_name_in_ui: "Carprovet-Chewable-Tablets-75-mg-60-count",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chewable Tablets 75 mg, 60 count",
  },
  {
    display_name_in_ui: "Carprovet-Chews",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Chews",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets-100mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets 100mg 180 ct",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets-100mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets 100mg 60 ct",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets-25mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets 25mg 180 ct",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets-25mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets 25mg 60 ct",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets-75mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets 75mg 180 ct",
  },
  {
    display_name_in_ui: "Carprovet-Flavored-Tablets-75mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Flavored Tablets 75mg 60 ct",
  },
  {
    display_name_in_ui: "Carprovet-Injectable",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Injectable",
  },
  {
    display_name_in_ui: "Carprovet-Injectable-50mg-mL-20mL-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Carprovet Injectable 50mg/mL 20mL vial",
  },
  {
    display_name_in_ui: "Carter-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Carter Veterinary Services",
  },
  {
    display_name_in_ui: "Cat-Lax-56-7g-Tube",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Cat Lax 56.7g Tube",
  },
  {
    display_name_in_ui: "CatLax",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "CatLax",
  },
  {
    display_name_in_ui: "CatLax-Gel",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "CatLax Gel",
  },
  {
    display_name_in_ui: "Catney-One",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Catney One",
  },
  {
    display_name_in_ui: "Catney-One-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Catney One",
  },
  {
    display_name_in_ui: "Catney-One-520mg-30-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Catney One 520mg 30 ct",
  },
  {
    display_name_in_ui: "Catskill-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Catskill Veterinary Services",
  },
  {
    display_name_in_ui: "Cave-Creek-Equine-Sports-Medicine-Surgery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cave Creek Equine Sports Medicine & Surgery",
  },
  {
    display_name_in_ui: "Cedar-Hill-Mobile-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cedar Hill Mobile Equine",
  },
  {
    display_name_in_ui: "Cefpoderm",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Cefpoderm",
  },
  {
    display_name_in_ui: "Cefpoderm-100mg-Tablets",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Cefpoderm 100mg Tablets",
  },
  {
    display_name_in_ui: "Cefpoderm-200mg-Tablets",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Cefpoderm 200mg Tablets",
  },
  {
    display_name_in_ui: "Cefpoderm-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Cefpoderm Tablets",
  },
  {
    display_name_in_ui: "Central-Garden-Pet-Company",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Central Garden Pet Company",
  },
  {
    display_name_in_ui: "Central-Washington-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Central Washington Equine Hospital",
  },
  {
    display_name_in_ui: "Charter-Equine-and-Small-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Charter Equine and Small Animal Hospital",
  },
  {
    display_name_in_ui: "Chesapeake-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Chesapeake Veterinary Services",
  },
  {
    display_name_in_ui: "Chewy-com",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Chewy.com",
  },
  {
    display_name_in_ui: "Chewy-com-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Chewy.com",
  },
  {
    display_name_in_ui: "Chino-Valley-Equine-Hospital-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Chino Valley Equine Hospital Inc",
  },
  {
    display_name_in_ui: "Choice-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Choice Veterinary Services",
  },
  {
    display_name_in_ui: "CityVet-Parent",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "CityVet - Parent",
  },
  {
    display_name_in_ui: "CityVet-Parent-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "CityVet - Parent",
  },
  {
    display_name_in_ui: "Civano-Animal-Hospital-And-Emergency",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Civano Animal Hospital And Emergency",
  },
  {
    display_name_in_ui: "CK-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "CK Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Clark-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Clark Equine Clinic",
  },
  {
    display_name_in_ui: "Clavacillin",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin",
  },
  {
    display_name_in_ui: "Clavacillin-125-mg-210-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 125 mg 210 ct",
  },
  {
    display_name_in_ui: "Clavacillin-125-mg-70-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 125 mg 70 ct",
  },
  {
    display_name_in_ui: "Clavacillin-250-mg-210-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 250 mg 210 ct",
  },
  {
    display_name_in_ui: "Clavacillin-250-mg-70-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 250 mg 70 ct",
  },
  {
    display_name_in_ui: "Clavacillin-375-mg-210-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 375 mg 210 ct",
  },
  {
    display_name_in_ui: "Clavacillin-375-mg-70-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 375 mg 70 ct",
  },
  {
    display_name_in_ui: "Clavacillin-62-5-mg-210-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 62.5 mg 210 ct",
  },
  {
    display_name_in_ui: "Clavacillin-62-5-mg-70-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin 62.5 mg 70 ct",
  },
  {
    display_name_in_ui: "Clavacillin-Tablet",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Clavacillin Tablet",
  },
  {
    display_name_in_ui: "Cleary-Lake-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cleary Lake Veterinary Hospital",
  },
  {
    display_name_in_ui: "Clematis-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Clematis Animal Clinic",
  },
  {
    display_name_in_ui: "Clipper-Distributing-Company-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Clipper Distributing Company, LLC",
  },
  {
    display_name_in_ui: "Cloud-Peak-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cloud Peak Veterinary Services",
  },
  {
    display_name_in_ui: "Coastal-Animal-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Coastal Animal Medical Center",
  },
  {
    display_name_in_ui: "Coleman-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Coleman Veterinary Clinic",
  },
  {
    display_name_in_ui: "Collier-Equine-Vet-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Collier Equine Vet Service",
  },
  {
    display_name_in_ui: "Colorado-Equine-Vet-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Colorado Equine Vet Services",
  },
  {
    display_name_in_ui: "Colorado-State-University-Equine-Reproduction-Laboratory",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Colorado State University Equine Reproduction Laboratory",
  },
  {
    display_name_in_ui: "Community-Veterinary-Partners-CVP-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Community Veterinary Partners (CVP) - US",
  },
  {
    display_name_in_ui: "Community-Veterinary-Partners-CVP-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Community Veterinary Partners (CVP) - US",
  },
  {
    display_name_in_ui: "Companion",
    field_name: "Species",
    table_name: "",
    schema_name: "",
    entity_name: "Companion",
  },
  {
    display_name_in_ui: "Companion-Pet-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Companion Pet - US",
  },
  {
    display_name_in_ui: "Companion-Pet-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Companion Pet - US",
  },
  {
    display_name_in_ui: "Confluence-Equine-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Confluence Equine, LLC",
  },
  {
    display_name_in_ui: "Connecticut-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Connecticut Equine Clinic",
  },
  {
    display_name_in_ui: "Copper-Ridge-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Copper Ridge Equine",
  },
  {
    display_name_in_ui: "Corporate",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "Corporate",
  },
  {
    display_name_in_ui: "CosACTHen",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "CosACTHen",
  },
  {
    display_name_in_ui: "CosACTHen-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "CosACTHen",
  },
  {
    display_name_in_ui: "CosACTHen-cosyntropin-injection-0-25-mg-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "CosACTHen ® (cosyntropin injection) 0.25 mg/mL",
  },
  {
    display_name_in_ui: "Costco",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Costco",
  },
  {
    display_name_in_ui: "Countryside-Large-Animal-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Countryside Large Animal Veterinary Services",
  },
  {
    display_name_in_ui: "Countryside-Pet-Supply",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Countryside Pet Supply",
  },
  {
    display_name_in_ui: "Countryside-Veterinary-Services-KS",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Countryside Veterinary Services - KS",
  },
  {
    display_name_in_ui: "Countryside-Veterinary-Services-TN",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Countryside Veterinary Services - TN",
  },
  {
    display_name_in_ui: "Cove-Animal-Health",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Cove Animal Health",
  },
  {
    display_name_in_ui: "Cove-Animal-Health-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Cove Animal Health",
  },
  {
    display_name_in_ui: "Covetrus-North-America",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Covetrus North America",
  },
  {
    display_name_in_ui: "Craig-Road-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Craig Road Animal Hospital",
  },
  {
    display_name_in_ui: "Cranberry-Country-Equine-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cranberry Country Equine Veterinary Service",
  },
  {
    display_name_in_ui: "Creston-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Creston Veterinary Services",
  },
  {
    display_name_in_ui: "Crosby-Veterinary-Services-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Crosby Veterinary Services LLC",
  },
  {
    display_name_in_ui: "Cross-Creek-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cross Creek Equine",
  },
  {
    display_name_in_ui: "CSR-Company-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "CSR Company Inc",
  },
  {
    display_name_in_ui: "CSU-Veterinary-Teaching-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "CSU Veterinary Teaching Hospital",
  },
  {
    display_name_in_ui: "Cummings-School-of-Veterinary-Medicine-at-Tufts-University",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cummings School of Veterinary Medicine at Tufts University",
  },
  {
    display_name_in_ui: "Curo-Pet-Care-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Curo Pet Care - US",
  },
  {
    display_name_in_ui: "Curo-Pet-Care-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Curo Pet Care - US",
  },
  {
    display_name_in_ui: "Cutting-Edge-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Cutting Edge Veterinary Services",
  },
  {
    display_name_in_ui: "Dakota-Large-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dakota Large Animal Clinic",
  },
  {
    display_name_in_ui: "Daniel-Equine-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Daniel Equine Services",
  },
  {
    display_name_in_ui: "DaSilva-Equine-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "DaSilva Equine Sports Medicine",
  },
  {
    display_name_in_ui: "Davie-County-Large-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Davie County Large Animal Hospital",
  },
  {
    display_name_in_ui: "Davis-Equine-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Davis Equine Sports Medicine",
  },
  {
    display_name_in_ui: "Dechra-Korea-EN475",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dechra Korea (EN475)",
  },
  {
    display_name_in_ui: "Dechra-Productos-Veterinarios-SA-de-CV-EN420",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dechra Productos Veterinarios SA de CV (EN420)",
  },
  {
    display_name_in_ui: "Dechra-Veterinary-Products-NZ-Ltd-EN481",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dechra Veterinary Products NZ Ltd (EN481)",
  },
  {
    display_name_in_ui: "Dechra-Veterinary-Products-Inc-EN410",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dechra Veterinary Products, Inc (EN410)",
  },
  {
    display_name_in_ui: "DeCillo-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "DeCillo Equine Clinic",
  },
  {
    display_name_in_ui: "Dells-Equine-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dells Equine Veterinary Service",
  },
  {
    display_name_in_ui: "Delmarva-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Delmarva Equine Clinic",
  },
  {
    display_name_in_ui: "DentAcetic",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "DentAcetic",
  },
  {
    display_name_in_ui: "DentAcetic-DenTees-Chews-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DentAcetic DenTees Chews 12oz",
  },
  {
    display_name_in_ui: "DentAcetic-DenTees-Stars",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DentAcetic DenTees Stars",
  },
  {
    display_name_in_ui: "DentAcetic-Gel",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DentAcetic Gel",
  },
  {
    display_name_in_ui: "DentAcetic-Gel-2oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DentAcetic Gel 2oz",
  },
  {
    display_name_in_ui: "DentAcetic-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DentAcetic Wipes",
  },
  {
    display_name_in_ui: "Dental",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Dental",
  },
  {
    display_name_in_ui: "Dentees",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Dentees",
  },
  {
    display_name_in_ui: "Dentees-Chews",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Dentees Chews",
  },
  {
    display_name_in_ui: "DermaBenS",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "DermaBenS",
  },
  {
    display_name_in_ui: "DermaBenS-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DermaBenS Shampoo",
  },
  {
    display_name_in_ui: "DermaBens-Shampoo-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermaBens Shampoo 12oz",
  },
  {
    display_name_in_ui: "DermaBensS-Shampoo-Gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermaBensS Shampoo Gal",
  },
  {
    display_name_in_ui: "DermAllay",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay",
  },
  {
    display_name_in_ui: "DermAllay-Conditioner-Gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay Conditioner Gal",
  },
  {
    display_name_in_ui: "DermAllay-Oatmeal-Spray-Cond-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay Oatmeal Spray Cond 8oz",
  },
  {
    display_name_in_ui: "DermAllay-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay Shampoo",
  },
  {
    display_name_in_ui: "Dermallay-Shampoo-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Dermallay Shampoo 12oz",
  },
  {
    display_name_in_ui: "DermAllay-Shampoo-Gallon",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay Shampoo Gallon",
  },
  {
    display_name_in_ui: "DermAllay-Spray-Conditioner-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay Spray Conditioner 12oz",
  },
  {
    display_name_in_ui: "DermAllay-Spray-Conditioner",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DermAllay Spray/Conditioner",
  },
  {
    display_name_in_ui: "DermaLyte",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "DermaLyte",
  },
  {
    display_name_in_ui: "DermaLyte-Gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DermaLyte Gal",
  },
  {
    display_name_in_ui: "DermaLyte-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DermaLyte Shampoo",
  },
  {
    display_name_in_ui: "Dermalyte-Shampoo-12OZ",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Dermalyte Shampoo 12OZ",
  },
  {
    display_name_in_ui: "Desert-Mountain-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Desert Mountain Equine",
  },
  {
    display_name_in_ui: "Desert-Pines-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Desert Pines Equine",
  },
  {
    display_name_in_ui: "DESTINATION-PET-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "DESTINATION PET - US",
  },
  {
    display_name_in_ui: "DESTINATION-PET-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "DESTINATION PET - US",
  },
  {
    display_name_in_ui: "Dexmedesed",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Dexmedesed",
  },
  {
    display_name_in_ui: "Dexmedesed-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Dexmedesed Injection",
  },
  {
    display_name_in_ui: "Dexmedesed-Injection-0-5mg-mL-10mL-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Dexmedesed Injection 0.5mg/mL 10mL vial",
  },
  {
    display_name_in_ui: "Dey-Equine-Veterinarians",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dey Equine Veterinarians",
  },
  {
    display_name_in_ui: "Diverter",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "Diverter",
  },
  {
    display_name_in_ui: "Diverter-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Diverter",
  },
  {
    display_name_in_ui: "DO-NOT-USE-Noble-Equine-Veterinary-Service-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "DO NOT USE Noble Equine Veterinary Service, PLLC",
  },
  {
    display_name_in_ui: "Domidine",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Domidine",
  },
  {
    display_name_in_ui: "Domidine-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Domidine",
  },
  {
    display_name_in_ui: "Domidine-detomidine-hydrochloride-20-mL-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Domidine™ (detomidine hydrochloride) 20 mL vial",
  },
  {
    display_name_in_ui: "Domidine-detomidine-hydrochloride-5-mL-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Domidine™ (detomidine hydrochloride) 5 mL vial",
  },
  {
    display_name_in_ui: "Doorstep-DVM-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Doorstep DVM LLC",
  },
  {
    display_name_in_ui: "Double-X-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Double X Veterinary Services",
  },
  {
    display_name_in_ui: "Dr-Cattrina-Lucas-Vet-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dr Cattrina Lucas Vet Inc",
  },
  {
    display_name_in_ui: "Dr-J-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dr J Veterinary Services",
  },
  {
    display_name_in_ui: "Dr-Vos-Vet-Consult",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Dr Vos Vet Consult",
  },
  {
    display_name_in_ui: "DuOtic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "DuOtic",
  },
  {
    display_name_in_ui: "DuOtic-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "DuOtic",
  },
  {
    display_name_in_ui: "DuOtic-1-mL-tube-2-pack",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DuOtic 1 mL tube, 2 pack",
  },
  {
    display_name_in_ui: "DuOtic-1-mL-tube-20-pack",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "DuOtic 1 mL tube, 20 pack",
  },
  {
    display_name_in_ui: "Duramectin-Paste-6-08GM",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Duramectin Paste 6.08GM",
  },
  {
    display_name_in_ui: "Durango-Equine-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Durango Equine Veterinary Clinic",
  },
  {
    display_name_in_ui: "Durvet-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Durvet Inc",
  },
  {
    display_name_in_ui: "Dutch-Pet",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Dutch Pet",
  },
  {
    display_name_in_ui: "East-Coast-Equine-Performance-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "East Coast Equine Performance LLC",
  },
  {
    display_name_in_ui: "East-County-Large-Animal-Practice",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "East County Large Animal Practice",
  },
  {
    display_name_in_ui: "Eastern-Equine-Associates-Mobile-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Eastern Equine Associates Mobile Veterinary Service",
  },
  {
    display_name_in_ui: "Eicosa",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Eicosa",
  },
  {
    display_name_in_ui: "Eicosa3FF",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Eicosa3FF",
  },
  {
    display_name_in_ui: "Eicosa3FF-Snip-Tips-Large-120ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Eicosa3FF Snip Tips Large 120ct",
  },
  {
    display_name_in_ui: "Eicosa3FF-Snip-Tips-Large-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Eicosa3FF Snip Tips Large 60ct",
  },
  {
    display_name_in_ui: "Eicosa3FF-Snip-Tips-Small-120ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Eicosa3FF Snip Tips Small 120ct",
  },
  {
    display_name_in_ui: "Eicosa3FF-Snip-Tips-Small-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Eicosa3FF Snip Tips Small 60ct",
  },
  {
    display_name_in_ui: "EicosaCaps",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "EicosaCaps",
  },
  {
    display_name_in_ui: "EicosaCaps-L-Omega-3-40-70lb-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EicosaCaps L Omega 3 40-70lb 60ct",
  },
  {
    display_name_in_ui: "EicosaCaps-Omega-3-under-40lb-60caps",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EicosaCaps Omega 3 under 40lb 60caps",
  },
  {
    display_name_in_ui: "EicosaDerm",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "EicosaDerm",
  },
  {
    display_name_in_ui: "EicosaDerm-32oz-pump",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EicosaDerm 32oz pump",
  },
  {
    display_name_in_ui: "EicosaDerm-8oz-pump",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EicosaDerm 8oz pump",
  },
  {
    display_name_in_ui: "El-Cajon-Valley-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "El Cajon Valley Veterinary Hospital",
  },
  {
    display_name_in_ui: "Elgin-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Elgin Veterinary Hospital",
  },
  {
    display_name_in_ui: "Emeprev",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev",
  },
  {
    display_name_in_ui: "Emeprev-Injectable",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Injectable",
  },
  {
    display_name_in_ui: "Emeprev-Injectable-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Injectable",
  },
  {
    display_name_in_ui: "Emeprev-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-160mg-4-ct-strip",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 160mg 4 ct strip",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-160mg-60-ct-bottle",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 160mg 60 ct bottle",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-16mg-4-ct-Strip",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 16mg 4 ct Strip",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-16mg-60-ct-bottle",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 16mg 60 ct bottle",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-24-mg-4-ct-Strip",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 24 mg 4 ct Strip",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-24mg-60-ct-bottle",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 24mg 60 ct bottle",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-60mg-4-ct-strip",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 60mg 4 ct strip",
  },
  {
    display_name_in_ui: "Emeprev-Tablets-60mg-60-ct-bottle",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev Tablets 60mg 60 ct bottle",
  },
  {
    display_name_in_ui: "Emeprev-maropitant-citrate-Injectable-Solution-10mg-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Emeprev™ (maropitant citrate) Injectable Solution 10mg/mL",
  },
  {
    display_name_in_ui: "Empire-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Empire Equine",
  },
  {
    display_name_in_ui: "Encore-Vet-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Encore Vet - US",
  },
  {
    display_name_in_ui: "Encore-Vet-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Encore Vet - US",
  },
  {
    display_name_in_ui: "Endocrine",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Endocrine",
  },
  {
    display_name_in_ui: "Enroquin",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin",
  },
  {
    display_name_in_ui: "Enroquin-136-mg-Flavored-Tablets-200-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin 136 mg Flavored Tablets 200 ct",
  },
  {
    display_name_in_ui: "Enroquin-136-mg-Flavored-Tablets-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin 136 mg Flavored Tablets 50 ct",
  },
  {
    display_name_in_ui: "Enroquin-22-7-mg-Flavored-Tablets-100-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin 22.7 mg Flavored Tablets 100 ct",
  },
  {
    display_name_in_ui: "Enroquin-22-7-mg-Flavored-Tablets-500-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin 22.7 mg Flavored Tablets 500 ct",
  },
  {
    display_name_in_ui: "Enroquin-68-mg-Flavored-Tablets-250-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin 68 mg Flavored Tablets 250 ct",
  },
  {
    display_name_in_ui: "Enroquin-68-mg-Flavored-Tablets-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin 68 mg Flavored Tablets 50 ct",
  },
  {
    display_name_in_ui: "Enroquin-Antibacterial-Injectable-Solution-2-27-20mL-Vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin Antibacterial Injectable Solution 2.27% 20mL Vial",
  },
  {
    display_name_in_ui: "Enroquin-Flavored-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin Flavored Tablets",
  },
  {
    display_name_in_ui: "Enroquin-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Enroquin Injection",
  },
  {
    display_name_in_ui: "EpiKalm",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKalm",
  },
  {
    display_name_in_ui: "EpiKalm-Ear-Cleanser-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKalm Ear Cleanser 12oz",
  },
  {
    display_name_in_ui: "EpiKalm-Ear-Cleanser-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKalm Ear Cleanser 8oz",
  },
  {
    display_name_in_ui: "EpiKalm-Otic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKalm Otic",
  },
  {
    display_name_in_ui: "EpiKlean",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKlean",
  },
  {
    display_name_in_ui: "EpiKlean-Ear-Cleanser-32oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKlean Ear Cleanser 32oz",
  },
  {
    display_name_in_ui: "EpiKlean-Ear-Cleanser-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKlean Ear Cleanser 8oz",
  },
  {
    display_name_in_ui: "EpiKlean-Otic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKlean Otic",
  },
  {
    display_name_in_ui: "EpiKlean-Otic-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EpiKlean Otic 12oz",
  },
  {
    display_name_in_ui: "EpiTreats",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "EpiTreats",
  },
  {
    display_name_in_ui: "EpiTreats-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "EpiTreats",
  },
  {
    display_name_in_ui: "EpiTreats-8oz-Pouch",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "EpiTreats 8oz Pouch",
  },
  {
    display_name_in_ui: "Equidone",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Equidone",
  },
  {
    display_name_in_ui: "Equidone-Gel",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Equidone Gel",
  },
  {
    display_name_in_ui: "Equidone-Oral-Gel",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Equidone Oral Gel",
  },
  {
    display_name_in_ui: "Equilibrium-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equilibrium Veterinary Services",
  },
  {
    display_name_in_ui: "Equine",
    field_name: "Species",
    table_name: "",
    schema_name: "",
    entity_name: "Equine",
  },
  {
    display_name_in_ui: "Equine-1",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Equine",
  },
  {
    display_name_in_ui: "Equine-Athletes-Veterinary-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Athletes Veterinary Inc",
  },
  {
    display_name_in_ui: "Equine-Med-Sport",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Med Sport",
  },
  {
    display_name_in_ui: "Equine-Medical-Associates-PSC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Medical Associates PSC",
  },
  {
    display_name_in_ui: "Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Medical Center",
  },
  {
    display_name_in_ui: "Equine-Medical-Center-of-Ocala",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Medical Center of Ocala",
  },
  {
    display_name_in_ui: "Equine-Performance-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Performance Medicine",
  },
  {
    display_name_in_ui: "Equine-Performance-Veterinary-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Performance Veterinary Services PLLC",
  },
  {
    display_name_in_ui: "Equine-Performax-Vet-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Performax Vet Services",
  },
  {
    display_name_in_ui: "Equine-Podiatry-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Podiatry Services",
  },
  {
    display_name_in_ui: "Equine-Services-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Services LLC",
  },
  {
    display_name_in_ui: "Equine-Specialty-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Specialty Hospital",
  },
  {
    display_name_in_ui: "Equine-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Sports Medicine",
  },
  {
    display_name_in_ui: "Equine-Sports-Medicine-Surgery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Sports Medicine & Surgery",
  },
  {
    display_name_in_ui: "Equine-Sports-Medicine-LRO-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Sports Medicine LRO Inc",
  },
  {
    display_name_in_ui: "Equine-Sports-Medicine-of-Maryland",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Sports Medicine of Maryland",
  },
  {
    display_name_in_ui: "Equine-Therapeutics-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Therapeutics Veterinary Services",
  },
  {
    display_name_in_ui: "Equine-Therapies",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Therapies",
  },
  {
    display_name_in_ui: "Equine-Veterinary-Clinic-of-Tucson",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Veterinary Clinic of Tucson",
  },
  {
    display_name_in_ui: "Equine-Veterinary-Hospital-of-Northern-Indiana-PC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Veterinary Hospital of Northern Indiana PC",
  },
  {
    display_name_in_ui: "Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Equitage-Horsecare",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Equitage Horsecare",
  },
  {
    display_name_in_ui: "Erskine-Associates-Equine-Veterinary-Practice-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Erskine & Associates Equine Veterinary Practice LLC",
  },
  {
    display_name_in_ui: "ESP-Alternative-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "ESP Alternative LLC",
  },
  {
    display_name_in_ui: "Ethos-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Ethos - US",
  },
  {
    display_name_in_ui: "Euthanasia",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Euthanasia",
  },
  {
    display_name_in_ui: "Euthaphen",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Euthaphen",
  },
  {
    display_name_in_ui: "Euthaphen-Euthanasia-Solution-100-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Euthaphen (Euthanasia Solution) 100 mL",
  },
  {
    display_name_in_ui: "Euthaphen-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Euthaphen Injection",
  },
  {
    display_name_in_ui: "Evergreen-Equine-Veterinary-Practice",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Evergreen Equine Veterinary Practice",
  },
  {
    display_name_in_ui: "EverVet-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "EverVet Group",
  },
  {
    display_name_in_ui: "EverVet-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "EverVet Group",
  },
  {
    display_name_in_ui: "F-Fluitt-Performance-Horse-Medicine-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "F Fluitt Performance Horse Medicine Inc",
  },
  {
    display_name_in_ui: "F9-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "F9 Equine Clinic",
  },
  {
    display_name_in_ui: "Family-Farm-and-Home",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Family Farm and Home",
  },
  {
    display_name_in_ui: "Farmington-Equine-Associates",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Farmington Equine Associates",
  },
  {
    display_name_in_ui: "FarmVet",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "FarmVet",
  },
  {
    display_name_in_ui: "Felimazole",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Felimazole",
  },
  {
    display_name_in_ui: "Felimazole-2-5mg-100Tabs",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Felimazole 2.5mg - 100Tabs",
  },
  {
    display_name_in_ui: "Felimazole-5-0mg-100Tabs",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Felimazole 5.0mg - 100Tabs",
  },
  {
    display_name_in_ui: "Felimazole-Coated-Tabs",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Felimazole Coated Tabs",
  },
  {
    display_name_in_ui: "Fieldstone-Equine-Clinic-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Fieldstone Equine Clinic PLLC",
  },
  {
    display_name_in_ui: "Finish-Line-Equine-Surgery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Finish Line Equine Surgery",
  },
  {
    display_name_in_ui: "Firovet",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Firovet",
  },
  {
    display_name_in_ui: "Firovet-firocoxib-Flavored-Tablets-227mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Firovet (firocoxib) Flavored Tablets 227mg 180 ct",
  },
  {
    display_name_in_ui: "Firovet-firocoxib-Flavored-Tablets-227mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Firovet (firocoxib) Flavored Tablets 227mg 60 ct",
  },
  {
    display_name_in_ui: "Firovet-firocoxib-Flavored-Tablets-57mg-180-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Firovet (firocoxib) Flavored Tablets 57mg 180 ct",
  },
  {
    display_name_in_ui: "Firovet-firocoxib-Flavored-Tablets-57mg-60-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Firovet (firocoxib) Flavored Tablets 57mg 60 ct",
  },
  {
    display_name_in_ui: "Firovet-Flavored-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Firovet Flavored Tablets",
  },
  {
    display_name_in_ui: "First-Veterinary-Supply-Harvard-Drug-Group-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "First Veterinary Supply - Harvard Drug Group LLC",
  },
  {
    display_name_in_ui: "Flint-Hills-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Flint Hills Veterinary Hospital",
  },
  {
    display_name_in_ui: "FlorCon",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "FlorCon",
  },
  {
    display_name_in_ui: "FlorCon-Solution",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "FlorCon Solution",
  },
  {
    display_name_in_ui: "FlorCon-Solution-2-2-L",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "FlorCon Solution 2.2 L",
  },
  {
    display_name_in_ui: "Fluid-Therapy",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Fluid Therapy",
  },
  {
    display_name_in_ui: "Food-Animal",
    field_name: "Species",
    table_name: "",
    schema_name: "",
    entity_name: "Food Animal",
  },
  {
    display_name_in_ui: "Foothills-Large-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Foothills Large Animal Hospital",
  },
  {
    display_name_in_ui: "Ford-Veterinary-Surgery-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ford Veterinary Surgery Center",
  },
  {
    display_name_in_ui: "Fordham-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Fordham Equine",
  },
  {
    display_name_in_ui: "Fox-Valley-Equine-Practice",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Fox Valley Equine Practice",
  },
  {
    display_name_in_ui: "Fraley-Equine-Podiatry",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Fraley Equine Podiatry",
  },
  {
    display_name_in_ui: "Franklin-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Franklin Veterinary Clinic",
  },
  {
    display_name_in_ui: "Fredericksburg-Equine-Small-Animal",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Fredericksburg Equine & Small Animal",
  },
  {
    display_name_in_ui: "Freedom-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Freedom Equine",
  },
  {
    display_name_in_ui: "Freedom-Run-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Freedom Run Equine",
  },
  {
    display_name_in_ui: "Front-Range-Equine-Performance",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Front Range Equine Performance",
  },
  {
    display_name_in_ui: "G-R-Longworth-VMD-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "G R Longworth VMD LLC",
  },
  {
    display_name_in_ui: "GentaCalm",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "GentaCalm",
  },
  {
    display_name_in_ui: "GentaCalm-Spray",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "GentaCalm Spray",
  },
  {
    display_name_in_ui: "GentaCalm-Spray-120ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "GentaCalm Spray 120ml",
  },
  {
    display_name_in_ui: "GentaCalm-Spray-60ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "GentaCalm Spray 60ml",
  },
  {
    display_name_in_ui: "George-County-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "George County Veterinary Clinic",
  },
  {
    display_name_in_ui: "Glen-Haven",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven",
  },
  {
    display_name_in_ui: "Glen-Haven-Benasoothe-Conditioner-8-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Benasoothe Conditioner  8 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Benasoothe-Shampoo-12-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Benasoothe Shampoo 12 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Cerumotic-4-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Cerumotic 4 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Conditioner",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Conditioner",
  },
  {
    display_name_in_ui: "Glen-Haven-Gentle-Cleansing-Wipes",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Gentle Cleansing Wipes",
  },
  {
    display_name_in_ui: "Glen-Haven-Hexachlor-K-Conditioner-8-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Hexachlor K Conditioner 8 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Hexachlor-K-Wipes-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Hexachlor K Wipes 50 ct",
  },
  {
    display_name_in_ui: "Glen-Haven-Hexachlor-K-Shampoo-12-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Hexachlor-K Shampoo  12 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-HypoAllergenic-Creme-Rinse",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven HypoAllergenic Creme Rinse",
  },
  {
    display_name_in_ui: "Glen-Haven-Miconazole-Shampoo-12-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Miconazole Shampoo 12 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Oti-Tris-Flush-4-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Oti-Tris Flush 4 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Otic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Otic",
  },
  {
    display_name_in_ui: "Glen-Haven-Oticetic-Flush-4-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Oticetic Flush  4 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Oticetic-Flush-12-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Oticetic Flush 12 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Oticetic-Flush-Medicated-8-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Oticetic Flush Medicated 8 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Shampoo",
  },
  {
    display_name_in_ui: "Glen-Haven-Trizchlor-4-Shampoo-12-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Trizchlor 4 Shampoo  12 oz",
  },
  {
    display_name_in_ui: "Glen-Haven-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Glen Haven Wipes",
  },
  {
    display_name_in_ui: "Glenwood-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Glenwood Veterinary Clinic",
  },
  {
    display_name_in_ui: "Gold-Coast-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Gold Coast Equine",
  },
  {
    display_name_in_ui: "Granbury-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Granbury Animal Clinic",
  },
  {
    display_name_in_ui: "Grand-Prix-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Grand Prix Equine",
  },
  {
    display_name_in_ui: "Granite-Bay-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Granite Bay Equine",
  },
  {
    display_name_in_ui: "Granville-Veterinary-Service-LA",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Granville Veterinary Service LA",
  },
  {
    display_name_in_ui: "Greater-Good-Charities",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Greater Good Charities",
  },
  {
    display_name_in_ui: "Greenville-Equine-Veterinary-Services-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Greenville Equine Veterinary Services LLC",
  },
  {
    display_name_in_ui: "Greenville-Mobile-Equine-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Greenville Mobile Equine Service",
  },
  {
    display_name_in_ui: "Groton-Vet-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Groton Vet Clinic",
  },
  {
    display_name_in_ui: "H-C-Animal-Health-LLC-COLLECTIONS",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "H & C Animal Health LLC - COLLECTIONS",
  },
  {
    display_name_in_ui: "Hadley-Hill-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hadley Hill Equine",
  },
  {
    display_name_in_ui: "Haffner-Equine-Veterinary-Services-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Haffner Equine Veterinary Services, LLC",
  },
  {
    display_name_in_ui: "Hagyard-Equine-Medical-Insitute",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hagyard Equine Medical Insitute",
  },
  {
    display_name_in_ui: "Hancock-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hancock Animal Clinic",
  },
  {
    display_name_in_ui: "Hardy-Paw",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Hardy Paw",
  },
  {
    display_name_in_ui: "Harrison-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Harrison Veterinary Clinic",
  },
  {
    display_name_in_ui: "Hassayampa-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hassayampa Veterinary Services",
  },
  {
    display_name_in_ui: "Hassinger-Equine-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hassinger Equine Sports Medicine",
  },
  {
    display_name_in_ui: "Haven-Lake-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Haven Lake Animal Hospital",
  },
  {
    display_name_in_ui: "Healthy-Pets",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Healthy Pets",
  },
  {
    display_name_in_ui: "Heart-and-Paw-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Heart and Paw Group",
  },
  {
    display_name_in_ui: "Heart-and-Paw-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Heart and Paw Group",
  },
  {
    display_name_in_ui: "Heartland-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Heartland Equine Hospital",
  },
  {
    display_name_in_ui: "Heartland-Vet-Partners",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Heartland Vet Partners",
  },
  {
    display_name_in_ui: "Heartland-Veterinary-Partners-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Heartland Veterinary Partners - US",
  },
  {
    display_name_in_ui: "Heartland-Veterinary-Partners-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Heartland Veterinary Partners - US",
  },
  {
    display_name_in_ui: "Heartland-Veterinary-Supply-and-Pharmacy-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Heartland Veterinary Supply and Pharmacy, LLC",
  },
  {
    display_name_in_ui: "High-Country-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "High Country Veterinary Services",
  },
  {
    display_name_in_ui: "High-Performance-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "High Performance Equine",
  },
  {
    display_name_in_ui: "Highland-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Highland Equine Hospital",
  },
  {
    display_name_in_ui: "Hillsborough-County-Pet-Resource-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hillsborough County Pet Resource Center",
  },
  {
    display_name_in_ui: "Hillside-Veterinary-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hillside Veterinary Services PLLC",
  },
  {
    display_name_in_ui: "Hilt-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hilt Veterinary Services",
  },
  {
    display_name_in_ui: "Hollendonner-Equine-Vet-Serv-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hollendonner Equine Vet Serv. LLC",
  },
  {
    display_name_in_ui: "Hollywood-Feed-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hollywood Feed  LLC",
  },
  {
    display_name_in_ui: "Horner-and-Nash-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Horner and Nash DVM",
  },
  {
    display_name_in_ui: "Horse-Health-Equine-Ivermectin-Paste-1-87",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Horse Health Equine Ivermectin Paste 1.87%",
  },
  {
    display_name_in_ui: "HSB-Veterinary-Supply-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "HSB Veterinary Supply, Inc",
  },
  {
    display_name_in_ui: "Hub-City-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hub City Veterinary Clinic",
  },
  {
    display_name_in_ui: "Human",
    field_name: "Species",
    table_name: "",
    schema_name: "",
    entity_name: "Human",
  },
  {
    display_name_in_ui: "Humphrey-Giacopuzzi-Associates-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Humphrey, Giacopuzzi & Associates Equine Hospital",
  },
  {
    display_name_in_ui: "Hurricane-Veterinary-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Hurricane Veterinary Services PLLC",
  },
  {
    display_name_in_ui: "Hypoallergenic-Cream-Rinse",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Hypoallergenic Cream Rinse",
  },
  {
    display_name_in_ui: "Hypoallergenic-Cream-Rinse-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Hypoallergenic Cream Rinse",
  },
  {
    display_name_in_ui: "Hypoallergenic-Cream-Rinse-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Hypoallergenic Cream Rinse 8oz",
  },
  {
    display_name_in_ui: "Idaho-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Idaho Equine Hospital",
  },
  {
    display_name_in_ui: "Independent",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "Independent",
  },
  {
    display_name_in_ui: "Independent-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Independent",
  },
  {
    display_name_in_ui: "Independent-Pet-Supply",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Independent Pet Supply",
  },
  {
    display_name_in_ui: "Innovetive-Petcare-Holdings-LLC-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Innovetive Petcare Holdings LLC - US",
  },
  {
    display_name_in_ui: "Innovetive-Petcare-Holdings-LLC-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Innovetive Petcare Holdings LLC - US",
  },
  {
    display_name_in_ui: "Institute-Mobile-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Institute Mobile Veterinary Services",
  },
  {
    display_name_in_ui: "Interstate-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Interstate Equine Hospital",
  },
  {
    display_name_in_ui: "Iowa-Equine-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Iowa Equine LLC",
  },
  {
    display_name_in_ui: "Iowa-State-University-of-Science-and-Technology",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Iowa State University of Science and Technology",
  },
  {
    display_name_in_ui: "Isoflurane",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Isoflurane",
  },
  {
    display_name_in_ui: "Isoflurane-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Isoflurane",
  },
  {
    display_name_in_ui: "Isospire-isoflurane-250-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Isospire (isoflurane)  250 mL",
  },
  {
    display_name_in_ui: "IverCare-Ivermectin-Paste-1-87",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "IverCare (Ivermectin) Paste 1.87%",
  },
  {
    display_name_in_ui: "IverCare-Equine-Paste-24-CS",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "IverCare Equine Paste 24/CS",
  },
  {
    display_name_in_ui: "Ivermectin",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Ivermectin",
  },
  {
    display_name_in_ui: "Ivermectin-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Ivermectin",
  },
  {
    display_name_in_ui: "Ivermectin-Paste-1-87-6-08-gram-syringe",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Ivermectin Paste 1.87% 6.08 gram syringe",
  },
  {
    display_name_in_ui: "Jackpot-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Jackpot Equine",
  },
  {
    display_name_in_ui: "Jacksonville-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Jacksonville Equine",
  },
  {
    display_name_in_ui: "James-River-Equine-Services-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "James River Equine Services, Inc",
  },
  {
    display_name_in_ui: "Jennifer-Wright-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Jennifer Wright DVM",
  },
  {
    display_name_in_ui: "Jensen-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Jensen Equine",
  },
  {
    display_name_in_ui: "Jenson-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Jenson Equine Hospital",
  },
  {
    display_name_in_ui: "John-R-Cummins-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "John R Cummins DVM",
  },
  {
    display_name_in_ui: "Jordan-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Jordan Equine",
  },
  {
    display_name_in_ui: "JVC-LLC-Rusty-Ridge-Animal-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "JVC LLC Rusty Ridge Animal Center",
  },
  {
    display_name_in_ui: "Kendall-Road-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Kendall Road Equine Hospital",
  },
  {
    display_name_in_ui: "Kennedy-Equine-PC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Kennedy Equine PC",
  },
  {
    display_name_in_ui: "Kentucky-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Kentucky Equine Hospital",
  },
  {
    display_name_in_ui: "Ketamine",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Ketamine",
  },
  {
    display_name_in_ui: "Ketamine-Hydrochloride-Inj-100mg-ml-10ml-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Ketamine Hydrochloride Inj 100mg/ml 10ml vial",
  },
  {
    display_name_in_ui: "Ketamine-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Ketamine Injection",
  },
  {
    display_name_in_ui: "Kim-Gill-Favier-DVM-CVA",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Kim Gill-Favier, DVM, CVA",
  },
  {
    display_name_in_ui: "King-Veterinary-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "King Veterinary Services PLLC",
  },
  {
    display_name_in_ui: "Klearotic",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Klearotic",
  },
  {
    display_name_in_ui: "KlearOtic-4oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "KlearOtic 4oz",
  },
  {
    display_name_in_ui: "Klearotic-Otic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Klearotic Otic",
  },
  {
    display_name_in_ui: "Kleinpeter-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Kleinpeter Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Koala-Pharmacy-boston",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Koala Pharmacy boston",
  },
  {
    display_name_in_ui: "Krause-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Krause Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Lake-Hamilton-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lake Hamilton Equine",
  },
  {
    display_name_in_ui: "Lakefield-Veterinary-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Lakefield Veterinary - US",
  },
  {
    display_name_in_ui: "Lakefield-Veterinary-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Lakefield Veterinary - US",
  },
  {
    display_name_in_ui: "Lakefield-Veterinary-Group-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lakefield Veterinary Group, Inc",
  },
  {
    display_name_in_ui: "Lambert-Vet-Supplies",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Lambert Vet Supplies",
  },
  {
    display_name_in_ui: "Lambert-Vet-Supply",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lambert Vet Supply",
  },
  {
    display_name_in_ui: "Land-O-Lakes-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Land O Lakes Equine",
  },
  {
    display_name_in_ui: "Laverdia",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia",
  },
  {
    display_name_in_ui: "Laverdia-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia",
  },
  {
    display_name_in_ui: "Laverdia-10mg-16ct-btl",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia 10mg, 16ct btl",
  },
  {
    display_name_in_ui: "Laverdia-2-5mg-16ct-btl",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia 2.5mg, 16ct btl",
  },
  {
    display_name_in_ui: "Laverdia-50mg-16ct-btl",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia 50mg, 16ct btl",
  },
  {
    display_name_in_ui: "Laverdia-CA1",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia-CA1",
  },
  {
    display_name_in_ui: "Laverdia-CA1-Tablet-10mg-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia-CA1 Tablet 10mg 50 ct",
  },
  {
    display_name_in_ui: "Laverdia-CA1-Tablet-2-5mg-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia-CA1 Tablet 2.5mg 50 ct",
  },
  {
    display_name_in_ui: "Laverdia-CA1-Tablet-50mg-16-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia-CA1 Tablet 50mg 16 ct",
  },
  {
    display_name_in_ui: "Laverdia-CA1-Tablet-50mg-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Laverdia-CA1 Tablet 50mg 50 ct",
  },
  {
    display_name_in_ui: "LB-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "LB Equine",
  },
  {
    display_name_in_ui: "Lebanon-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lebanon Equine Clinic",
  },
  {
    display_name_in_ui: "Ledford-Vet-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ledford Vet Services, PLLC",
  },
  {
    display_name_in_ui: "Lenape-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lenape Veterinary Clinic",
  },
  {
    display_name_in_ui: "Lewis-Clark-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lewis & Clark Animal Hospital",
  },
  {
    display_name_in_ui: "LimePlus",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "LimePlus",
  },
  {
    display_name_in_ui: "LimePlus-Dip",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "LimePlus Dip",
  },
  {
    display_name_in_ui: "Lisa-Campbell-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lisa Campbell DVM",
  },
  {
    display_name_in_ui: "Littleton-Large-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Littleton Large Animal Clinic",
  },
  {
    display_name_in_ui: "Livestock",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Livestock",
  },
  {
    display_name_in_ui: "Logan-Bethel-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Logan Bethel Veterinary Services",
  },
  {
    display_name_in_ui: "Loomis-Basin-Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Loomis Basin Equine Medical Center",
  },
  {
    display_name_in_ui: "Louisiana-State-University-Veterinary-Teaching-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Louisiana State University Veterinary Teaching Hospital",
  },
  {
    display_name_in_ui: "Lund-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Lund Equine",
  },
  {
    display_name_in_ui: "Mal-A-Ket",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket",
  },
  {
    display_name_in_ui: "Mal-A-Ket-TrizEdta-Spray-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket + TrizEdta Spray 8oz",
  },
  {
    display_name_in_ui: "Mal-A-Ket-Flush",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket Flush",
  },
  {
    display_name_in_ui: "Mal-A-Ket-Plus-TrizEdta-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket Plus TrizEdta 12oz",
  },
  {
    display_name_in_ui: "Mal-A-Ket-Plus-TrizEdta-4oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket Plus TrizEdta 4oz",
  },
  {
    display_name_in_ui: "Mal-A-Ket-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket Shampoo",
  },
  {
    display_name_in_ui: "Mal-A-Ket-Spray-Conditioner",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket Spray/Conditioner",
  },
  {
    display_name_in_ui: "Mal-A-Ket-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Mal-A-Ket Wipes",
  },
  {
    display_name_in_ui: "MalAcetic",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "MalAcetic",
  },
  {
    display_name_in_ui: "MalAcetic-Otic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MalAcetic Otic",
  },
  {
    display_name_in_ui: "Malacetic-Otic-AP-16oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malacetic Otic AP 16oz",
  },
  {
    display_name_in_ui: "Malacetic-Otic-Apple-4oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malacetic Otic Apple 4oz",
  },
  {
    display_name_in_ui: "Malacetic-Otic-Apple-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malacetic Otic Apple 8oz",
  },
  {
    display_name_in_ui: "MalAcetic-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MalAcetic Shampoo",
  },
  {
    display_name_in_ui: "Malacetic-Ultra-Otic-2oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malacetic Ultra Otic 2oz",
  },
  {
    display_name_in_ui: "Malacetic-Ultra-Otic-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malacetic Ultra Otic 8oz",
  },
  {
    display_name_in_ui: "MalAcetic-Wet-Wipes-Brick-25pk",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MalAcetic Wet Wipes Brick 25pk",
  },
  {
    display_name_in_ui: "MalAcetic-Wet-Wipes-dry-bath-100-ct-clinic",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MalAcetic Wet Wipes\\dry bath 100 ct clinic",
  },
  {
    display_name_in_ui: "MalAcetic-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MalAcetic Wipes",
  },
  {
    display_name_in_ui: "Malaket-Shampoo-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaket Shampoo 8oz",
  },
  {
    display_name_in_ui: "Malaket-Shampoo-Gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaket Shampoo Gal",
  },
  {
    display_name_in_ui: "Malaket-Wipes-25-50ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaket Wipes 25/50ct",
  },
  {
    display_name_in_ui: "Malaseb",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb",
  },
  {
    display_name_in_ui: "Malaseb-Flush",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Flush",
  },
  {
    display_name_in_ui: "Malaseb-Flush-12-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Flush 12 oz",
  },
  {
    display_name_in_ui: "Malaseb-Flush-4-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Flush 4 oz",
  },
  {
    display_name_in_ui: "Malaseb-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Shampoo",
  },
  {
    display_name_in_ui: "Malaseb-Shampoo-16-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Shampoo 16 oz",
  },
  {
    display_name_in_ui: "Malaseb-Shampoo-8-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Shampoo 8 oz",
  },
  {
    display_name_in_ui: "Malaseb-Spray",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Spray",
  },
  {
    display_name_in_ui: "Malaseb-Spray-8-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Malaseb Spray 8 oz",
  },
  {
    display_name_in_ui: "Marboquin",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets-100mg-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets 100mg 50 ct",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets-200mg-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets 200mg 50 ct",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets-25mg-100-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets 25mg 100 ct",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets-25mg-250-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets 25mg 250 ct",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets-50mg-100-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets 50mg 100 ct",
  },
  {
    display_name_in_ui: "Marboquin-Chewable-Tablets-50mg-250-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Chewable Tablets 50mg 250 ct",
  },
  {
    display_name_in_ui: "Marboquin-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Tablets",
  },
  {
    display_name_in_ui: "Marboquin-Tablets-100mg-50-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Tablets 100mg 50 ct",
  },
  {
    display_name_in_ui: "Marboquin-Tablets-25mg-100-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Tablets 25mg 100 ct",
  },
  {
    display_name_in_ui: "Marboquin-Tablets-25mg-250-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Tablets 25mg 250 ct",
  },
  {
    display_name_in_ui: "Marboquin-Tablets-50mg-100-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Tablets 50mg 100 ct",
  },
  {
    display_name_in_ui: "Marboquin-Tablets-50mg-250-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Marboquin Tablets 50mg 250 ct",
  },
  {
    display_name_in_ui: "MARS",
    field_name: "master_corporate_group",
    table_name: "",
    schema_name: "",
    entity_name: "MARS",
  },
  {
    display_name_in_ui: "MARS-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "MARS",
  },
  {
    display_name_in_ui: "Mary-Masterson-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mary Masterson DVM",
  },
  {
    display_name_in_ui: "Maryland-Vet-Group",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Maryland Vet Group",
  },
  {
    display_name_in_ui: "Maureen-Kelleher-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Maureen Kelleher DVM",
  },
  {
    display_name_in_ui: "McQuinn-Vet",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "McQuinn Vet",
  },
  {
    display_name_in_ui: "Medicine-Valley-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Medicine Valley Veterinary Hospital",
  },
  {
    display_name_in_ui: "MedVet-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "MedVet - US",
  },
  {
    display_name_in_ui: "MedVet-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "MedVet - US",
  },
  {
    display_name_in_ui: "Meeker-Equine-Sports-Medicine-PA",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Meeker Equine Sports Medicine, PA",
  },
  {
    display_name_in_ui: "Megan-Snyder-VMD",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Megan Snyder, VMD",
  },
  {
    display_name_in_ui: "Melinda-J-Blue-DVM-MS-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Melinda J Blue DVM MS Inc",
  },
  {
    display_name_in_ui: "Meloxivet",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Meloxivet",
  },
  {
    display_name_in_ui: "Meloxivet-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Meloxivet",
  },
  {
    display_name_in_ui: "Meloxivet-Solution-for-Injection-5-mg-mL-10mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Meloxivet Solution for Injection 5 mg/mL 10mL",
  },
  {
    display_name_in_ui: "Meloxivet-Solution-for-Injection-5-mg-mL-20mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Meloxivet Solution for Injection 5 mg/mL 20mL",
  },
  {
    display_name_in_ui: "Miami-Dade-County-Animal-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Miami Dade County Animal Services",
  },
  {
    display_name_in_ui: "MiconaHex",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex",
  },
  {
    display_name_in_ui: "MiconaHex-Triz-Shampoo-16oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex + Triz Shampoo 16oz",
  },
  {
    display_name_in_ui: "Miconahex-Triz-Shampoo-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Miconahex + Triz Shampoo 8oz",
  },
  {
    display_name_in_ui: "MiconaHex-Mousse",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex Mousse",
  },
  {
    display_name_in_ui: "MiconaHex-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex Shampoo",
  },
  {
    display_name_in_ui: "MiconaHex-Spray-Conditioner",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex Spray/Conditioner",
  },
  {
    display_name_in_ui: "MiconaHex-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex Wipes",
  },
  {
    display_name_in_ui: "MiconaHex-Triz-Mousse-7-1oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex+Triz Mousse 7.1oz",
  },
  {
    display_name_in_ui: "MICONAHEX-TRIZ-Shampoo-Gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MICONAHEX+TRIZ Shampoo Gal",
  },
  {
    display_name_in_ui: "MiconaHex-Triz-Spray-16oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex+Triz Spray 16oz",
  },
  {
    display_name_in_ui: "MiconaHex-Triz-Spray-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex+Triz Spray 8oz",
  },
  {
    display_name_in_ui: "MiconaHex-Triz-Wipes-50ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "MiconaHex+Triz Wipes 50ct",
  },
  {
    display_name_in_ui: "Mid-South-Equine-Sports-Medicine-Surgery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mid South Equine Sports Medicine Surgery",
  },
  {
    display_name_in_ui: "Midwest-Equine-Surgery-And-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Midwest Equine Surgery And Sports Medicine",
  },
  {
    display_name_in_ui: "Midwest-Veterinary-Supply-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Midwest Veterinary Supply, Inc",
  },
  {
    display_name_in_ui: "Milford-Animal-Hospital-II-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Milford Animal Hospital II LLC",
  },
  {
    display_name_in_ui: "Miller-O-Connor-Veterinary-Medicine-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Miller & O'Connor Veterinary Medicine, PLLC",
  },
  {
    display_name_in_ui: "Mirataz",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Mirataz",
  },
  {
    display_name_in_ui: "Mirataz-Ointment",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Mirataz Ointment",
  },
  {
    display_name_in_ui: "Mirataz-Transdermal-Ointment-5gm-Tube",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mirataz Transdermal Ointment 5gm Tube",
  },
  {
    display_name_in_ui: "Mission-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mission Equine Hospital",
  },
  {
    display_name_in_ui: "Mission-Pet-Health",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Mission Pet Health",
  },
  {
    display_name_in_ui: "Mission-Pet-Health-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Mission Pet Health",
  },
  {
    display_name_in_ui: "Mississippi-State-Univ-CVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mississippi State Univ - CVM",
  },
  {
    display_name_in_ui: "Mixed",
    field_name: "Species",
    table_name: "",
    schema_name: "",
    entity_name: "Mixed",
  },
  {
    display_name_in_ui: "Mobile-Veterinary-Practice",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mobile Veterinary Practice",
  },
  {
    display_name_in_ui: "Mobile-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mobile Veterinary Services",
  },
  {
    display_name_in_ui: "Mometavet",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Mometavet",
  },
  {
    display_name_in_ui: "Mometavet-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Mometavet",
  },
  {
    display_name_in_ui: "Mometavet-15gm",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mometavet 15gm",
  },
  {
    display_name_in_ui: "Mometavet-215gm",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mometavet 215gm",
  },
  {
    display_name_in_ui: "Mometavet-30gm",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mometavet 30gm",
  },
  {
    display_name_in_ui: "Mometavet-7-5gm",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mometavet 7.5gm",
  },
  {
    display_name_in_ui: "Moultrie-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Moultrie Animal Clinic",
  },
  {
    display_name_in_ui: "Mountain-Equine-Veterinary-Associates-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mountain Equine Veterinary Associates, Inc",
  },
  {
    display_name_in_ui: "Mozotic-Suspension-RX-15gm-PIV",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Mozotic Suspension (RX) 15gm PIV",
  },
  {
    display_name_in_ui: "MPX-Solubles",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "MPX Solubles",
  },
  {
    display_name_in_ui: "MPX-Solubles-1",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "MPX Solubles",
  },
  {
    display_name_in_ui: "MPX-Solubles-2",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "MPX Solubles",
  },
  {
    display_name_in_ui: "Mt-Baker-Veterinary",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mt Baker Veterinary",
  },
  {
    display_name_in_ui: "Mt-Laramie-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mt Laramie Veterinary Services",
  },
  {
    display_name_in_ui: "MU-Veterinary-Health-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "MU Veterinary Health Center",
  },
  {
    display_name_in_ui: "Mud-Bay-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Mud Bay, Inc",
  },
  {
    display_name_in_ui: "Muricin",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Muricin",
  },
  {
    display_name_in_ui: "Muricin-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Muricin",
  },
  {
    display_name_in_ui: "Muricin-Ointment",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Muricin Ointment",
  },
  {
    display_name_in_ui: "MVH-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "MVH Inc",
  },
  {
    display_name_in_ui: "MVP-EQUINE",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "MVP EQUINE",
  },
  {
    display_name_in_ui: "MWI-Veterinary-Supply",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "MWI Veterinary Supply",
  },
  {
    display_name_in_ui: "NC-State-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "NC State Veterinary Hospital",
  },
  {
    display_name_in_ui: "Nebraska-Equine-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Nebraska Equine Veterinary Clinic",
  },
  {
    display_name_in_ui: "Nenn-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Nenn Equine",
  },
  {
    display_name_in_ui: "NeoSol-Soluble-Powder-50Ibs",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "NeoSol Soluble Powder 50Ibs",
  },
  {
    display_name_in_ui: "New-England-Animal-Health",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "New England Animal Health",
  },
  {
    display_name_in_ui: "New-Jersey-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "New Jersey Equine Clinic",
  },
  {
    display_name_in_ui: "Noble-Equine-Services-Hwy-39-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Noble Equine Services Hwy 39 LLC",
  },
  {
    display_name_in_ui: "Non-Regulated-Derm",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Non-Regulated Derm",
  },
  {
    display_name_in_ui: "Nonprofit",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "Nonprofit",
  },
  {
    display_name_in_ui: "Nonprofit-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Nonprofit",
  },
  {
    display_name_in_ui: "North-Star-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "North Star Veterinary Hospital",
  },
  {
    display_name_in_ui: "North-Texas-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "North Texas Veterinary Hospital",
  },
  {
    display_name_in_ui: "Northrop-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Northrop Equine",
  },
  {
    display_name_in_ui: "Northside-Veterinay-Clinic-PC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Northside Veterinay Clinic, PC",
  },
  {
    display_name_in_ui: "Northwest-Equine-Performance",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Northwest Equine Performance",
  },
  {
    display_name_in_ui: "Novox-Caplets-100mg-180ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 100mg 180ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-100mg-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 100mg 30ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-100mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 100mg 60ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-25mg-180c",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 25mg 180c",
  },
  {
    display_name_in_ui: "Novox-Caplets-25mg-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 25mg 30ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-25mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 25mg 60ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-75mg-180ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 75mg 180ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-75mg-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 75mg 30ct",
  },
  {
    display_name_in_ui: "Novox-Caplets-75mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Caplets 75mg 60ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-100mg-180ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 100mg 180ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-100mg-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 100mg 30ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-100mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 100mg 60ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-25mg-180ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 25mg 180ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-25mg-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 25mg 30ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-25mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 25mg 60ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-75mg-180ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 75mg 180ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-75mg-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 75mg 30ct",
  },
  {
    display_name_in_ui: "Novox-Chewables-75mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Novox Chewables 75mg 60ct",
  },
  {
    display_name_in_ui: "NSAID",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "NSAID",
  },
  {
    display_name_in_ui: "NULL",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "NULL",
  },
  {
    display_name_in_ui: "NULL-1",
    field_name: "master_corporate_group",
    table_name: "",
    schema_name: "",
    entity_name: "NULL",
  },
  {
    display_name_in_ui: "NVA",
    field_name: "master_corporate_group",
    table_name: "",
    schema_name: "",
    entity_name: "NVA",
  },
  {
    display_name_in_ui: "NVA-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "NVA",
  },
  {
    display_name_in_ui: "NVA-Equine-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "NVA - Equine - US",
  },
  {
    display_name_in_ui: "NVA-GP-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "NVA - GP - US",
  },
  {
    display_name_in_ui: "Ocean-Hill-Equine-Medical-Group-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ocean Hill Equine Medical Group LLC",
  },
  {
    display_name_in_ui: "Odessa-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Odessa Equine",
  },
  {
    display_name_in_ui: "Oklahoma-City-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Oklahoma City Equine Clinic",
  },
  {
    display_name_in_ui: "Oklahoma-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Oklahoma Equine Hospital",
  },
  {
    display_name_in_ui: "Olde-Towne-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Olde Towne Equine",
  },
  {
    display_name_in_ui: "On-Point-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "On Point Animal Hospital",
  },
  {
    display_name_in_ui: "On-The-Fly-Equine-Veterinary",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "On The Fly Equine Veterinary",
  },
  {
    display_name_in_ui: "Oncology",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Oncology",
  },
  {
    display_name_in_ui: "One-Woman-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "One Woman Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Ophthalmic",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Ophthalmic",
  },
  {
    display_name_in_ui: "OphtHAvet",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet",
  },
  {
    display_name_in_ui: "OphtHAvet-Gel",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet Gel",
  },
  {
    display_name_in_ui: "OphtHAvet-Ointment",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet Ointment",
  },
  {
    display_name_in_ui: "OphtHAvet-Ophthalmic-Complete-Ophthalmic-Gel-10ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet Ophthalmic Complete Ophthalmic Gel 10ml",
  },
  {
    display_name_in_ui: "OphtHAvet-Ophthalmic-Ointment-5-gm",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet Ophthalmic Ointment 5 gm",
  },
  {
    display_name_in_ui: "OphtHAvet-Ophthalmic-Solution-10ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet Ophthalmic Solution 10ml",
  },
  {
    display_name_in_ui: "OphtHAvet-Solution",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "OphtHAvet Solution",
  },
  {
    display_name_in_ui: "Oregon-Equine-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Oregon Equine Inc",
  },
  {
    display_name_in_ui: "Orlando-Equine-Veterinary-Care",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Orlando Equine Veterinary Care",
  },
  {
    display_name_in_ui: "Orthokine",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Orthokine",
  },
  {
    display_name_in_ui: "Orthokine-IRAP",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Orthokine IRAP",
  },
  {
    display_name_in_ui: "Orthokine-Vet-Irap-10-3-10ml-syringes",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Orthokine Vet Irap 10 3/10ml syringes",
  },
  {
    display_name_in_ui: "Orthokine-Vet-Irap-60mL-Syringe",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Orthokine Vet Irap 60mL Syringe",
  },
  {
    display_name_in_ui: "OSPHOS",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "OSPHOS",
  },
  {
    display_name_in_ui: "Osphos-clodronate-injection-15ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Osphos (clodronate injection) 15ml",
  },
  {
    display_name_in_ui: "OSPHOS-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "OSPHOS Injection",
  },
  {
    display_name_in_ui: "Osteo",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Osteo",
  },
  {
    display_name_in_ui: "Osteokine",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Osteokine",
  },
  {
    display_name_in_ui: "Osteokine-EZ-PRP-Preperation-Device",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Osteokine EZ PRP Preperation Device",
  },
  {
    display_name_in_ui: "Osteokine-PRP",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Osteokine PRP",
  },
  {
    display_name_in_ui: "Osurnia",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Osurnia",
  },
  {
    display_name_in_ui: "Osurnia-1-mL-tube-2-pack",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Osurnia 1 mL tube,  2 pack",
  },
  {
    display_name_in_ui: "Osurnia-1-mL-tube-20-pack",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Osurnia 1 mL tube, 20 pack",
  },
  {
    display_name_in_ui: "Osurnia-Otic",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Osurnia Otic",
  },
  {
    display_name_in_ui: "Otterbein-University",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Otterbein University",
  },
  {
    display_name_in_ui: "Outlaw-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Outlaw Equine",
  },
  {
    display_name_in_ui: "Pacific-Equine-Veterinary-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pacific Equine Veterinary LLC",
  },
  {
    display_name_in_ui: "Pahoa-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pahoa Animal Hospital",
  },
  {
    display_name_in_ui: "Pallone-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pallone Veterinary Hospital",
  },
  {
    display_name_in_ui: "Palm-Beach-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Palm Beach Equine Clinic",
  },
  {
    display_name_in_ui: "Palmetto-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Palmetto Equine Hospital",
  },
  {
    display_name_in_ui: "Paragon-Pharmceuticals-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Paragon Pharmceuticals Inc",
  },
  {
    display_name_in_ui: "Park-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Park Equine Hospital",
  },
  {
    display_name_in_ui: "Paso-Robles-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Paso Robles Equine",
  },
  {
    display_name_in_ui: "Pathway-Vet-Alliance-US",
    field_name: "master_corporate_group",
    table_name: "",
    schema_name: "",
    entity_name: "Pathway Vet Alliance - US",
  },
  {
    display_name_in_ui: "Pathway-Vet-Alliance-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Pathway Vet Alliance - US",
  },
  {
    display_name_in_ui: "Paul-Wollenman-DVM-PA",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Paul Wollenman, DVM PA",
  },
  {
    display_name_in_ui: "Payne-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Payne Equine",
  },
  {
    display_name_in_ui: "Peak-Performance-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Peak Performance Equine Hospital",
  },
  {
    display_name_in_ui: "Peninsula-Animal-Hospital-and-Orthopedics",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Peninsula Animal Hospital and Orthopedics",
  },
  {
    display_name_in_ui: "Pentobarsol",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Pentobarsol",
  },
  {
    display_name_in_ui: "Pentobarsol-pentobarbital-sodium-Euthanasia-Injection-250-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Pentobarsol (pentobarbital sodium) Euthanasia Injection 250 mL",
  },
  {
    display_name_in_ui: "Pentobarsol-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Pentobarsol Injection",
  },
  {
    display_name_in_ui: "Performance-Equine-Associates-DBA-Easter-Troop-Assoc-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Performance Equine Associates DBA Easter, Troop & Assoc. LLC",
  },
  {
    display_name_in_ui: "Performance-Equine-Central-Coast",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Performance Equine Central Coast",
  },
  {
    display_name_in_ui: "Performance-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Performance Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Performance-Equine-Vets-SC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Performance Equine Vets SC",
  },
  {
    display_name_in_ui: "Performance-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Performance Veterinary Services",
  },
  {
    display_name_in_ui: "Peroxiderm-Shampoo-12oz-BF",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Peroxiderm Shampoo 12oz BF",
  },
  {
    display_name_in_ui: "Pet-Food-Express",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Pet Food Express",
  },
  {
    display_name_in_ui: "Pet-Supplies-Plus",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Pet Supplies Plus",
  },
  {
    display_name_in_ui: "Pet-Vet-Care-Centers-PVCC-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Pet Vet Care Centers (PVCC) - US",
  },
  {
    display_name_in_ui: "Pet-Vet-Care-Centers-PVCC-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Pet Vet Care Centers (PVCC) - US",
  },
  {
    display_name_in_ui: "Petaluma-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Petaluma Equine",
  },
  {
    display_name_in_ui: "PetCare-RX",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "PetCare RX",
  },
  {
    display_name_in_ui: "Petco",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Petco",
  },
  {
    display_name_in_ui: "Petco-Animal-Supplies-Stores-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Petco Animal Supplies Stores, Inc",
  },
  {
    display_name_in_ui: "Peterson-Smith-Equine-Hospital-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Peterson Smith Equine Hospital, LLC",
  },
  {
    display_name_in_ui: "PetFolk-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "PetFolk - US",
  },
  {
    display_name_in_ui: "PetFolk-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "PetFolk - US",
  },
  {
    display_name_in_ui: "PETIQ-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "PETIQ, LLC",
  },
  {
    display_name_in_ui: "PetMed-Express",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "PetMed Express",
  },
  {
    display_name_in_ui: "PetSmart",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "PetSmart",
  },
  {
    display_name_in_ui: "PetVet-Care-Centers",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "PetVet Care Centers",
  },
  {
    display_name_in_ui: "PetWell-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "PetWell Group",
  },
  {
    display_name_in_ui: "PetWell-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "PetWell Group",
  },
  {
    display_name_in_ui: "Philadelphia-Animal-Specialty-and-Emergency",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Philadelphia Animal Specialty and Emergency",
  },
  {
    display_name_in_ui: "Phillip-D-Hammock-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Phillip D Hammock DVM",
  },
  {
    display_name_in_ui: "Phoenix-Equine-Veterinarian-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Phoenix Equine Veterinarian Services",
  },
  {
    display_name_in_ui: "Phycox",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox",
  },
  {
    display_name_in_ui: "Phycox-EQ-Granules-2-88kg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox EQ Granules 2.88kg",
  },
  {
    display_name_in_ui: "Phycox-Granules",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Granules",
  },
  {
    display_name_in_ui: "Phycox-HA-Small-Bites-Soft-Chews-120s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox HA Small Bites Soft Chews 120s",
  },
  {
    display_name_in_ui: "Phycox-HA-Soft-Chews-120ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox HA Soft Chews 120ct",
  },
  {
    display_name_in_ui: "Phycox-K9-Granules-480g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox K9 Granules 480g",
  },
  {
    display_name_in_ui: "Phycox-K9-Granules-960g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox K9 Granules 960g",
  },
  {
    display_name_in_ui: "Phycox-Max-EQ-Granules-2700gr-tub",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Max EQ Granules 2700gr/tub",
  },
  {
    display_name_in_ui: "Phycox-Max-HA-Soft-Chews-90s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Max HA Soft Chews 90s",
  },
  {
    display_name_in_ui: "Phycox-Max-Sm-Bite-Soft-Chews-120-s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Max Sm Bite Soft Chews 120's",
  },
  {
    display_name_in_ui: "Phycox-MAX-Soft-Chews-90s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox MAX Soft Chews 90s",
  },
  {
    display_name_in_ui: "Phycox-Small-Bite-Soft-Chew",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Small Bite Soft Chew",
  },
  {
    display_name_in_ui: "Phycox-Small-Bites-Soft-Chews-120s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Small Bites Soft Chews 120s",
  },
  {
    display_name_in_ui: "Phycox-Soft-Chew",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Soft Chew",
  },
  {
    display_name_in_ui: "Phycox-Soft-Chews-120s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Soft Chews 120s",
  },
  {
    display_name_in_ui: "Phycox-Soft-Chews-60s",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Phycox Soft Chews 60s",
  },
  {
    display_name_in_ui: "Pierce-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pierce Veterinary Services",
  },
  {
    display_name_in_ui: "Pineview-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pineview Veterinary Hospital",
  },
  {
    display_name_in_ui: "Pinnacle-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pinnacle Equine Hospital",
  },
  {
    display_name_in_ui: "Pinnacle-Equine-Veterinary-Services-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Pinnacle Equine Veterinary Services PLLC",
  },
  {
    display_name_in_ui: "Porus-One",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Porus One",
  },
  {
    display_name_in_ui: "Porus-One-500mg-30-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Porus One 500mg 30 ct",
  },
  {
    display_name_in_ui: "Porus-One-Powder",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Porus One Powder",
  },
  {
    display_name_in_ui: "Priest-Equine-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Priest Equine LLC",
  },
  {
    display_name_in_ui: "ProbioWrap",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "ProbioWrap",
  },
  {
    display_name_in_ui: "ProbioWrap-Supplement",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "ProbioWrap Supplement",
  },
  {
    display_name_in_ui: "ProbioWrap-Supplement-4-2oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "ProbioWrap Supplement 4.2oz",
  },
  {
    display_name_in_ui: "Progressive-Equine-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Progressive Equine Inc",
  },
  {
    display_name_in_ui: "Provet",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Provet",
  },
  {
    display_name_in_ui: "ProVet-APC-System-Disposable-Kit",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "ProVet APC System Disposable Kit",
  },
  {
    display_name_in_ui: "ProVet-APC-System-30mL-Disposable-Kit-DOES-NOT-CONTAIN-ACDA",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "ProVet APC System- 30mL Disposable Kit (DOES NOT CONTAIN ACDA)",
  },
  {
    display_name_in_ui: "ProVet-APC-System-60mL-Disposable-Kit-DOES-NOT-CONTAIN-ACDA",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "ProVet APC System- 60mL Disposable Kit (DOES NOT CONTAIN ACDA)",
  },
  {
    display_name_in_ui: "ProVet-System-Centrifuge",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "ProVet System Centrifuge",
  },
  {
    display_name_in_ui: "ProVet-System-Centrifuge-1",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "ProVet System Centrifuge",
  },
  {
    display_name_in_ui: "Publix",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Publix",
  },
  {
    display_name_in_ui: "Puralube",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Puralube",
  },
  {
    display_name_in_ui: "Puralube-Ophthalmic-Ointment",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Puralube  Ophthalmic Ointment",
  },
  {
    display_name_in_ui: "Puralube-Ointment",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Puralube Ointment",
  },
  {
    display_name_in_ui: "Purdue-University",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Purdue University",
  },
  {
    display_name_in_ui: "Purvis-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Purvis Animal Clinic",
  },
  {
    display_name_in_ui: "Radkin-Equine-Podiatry-Mobile-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Radkin Equine Podiatry Mobile Service",
  },
  {
    display_name_in_ui: "Ramapo-Valley-Equine-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ramapo Valley Equine Services",
  },
  {
    display_name_in_ui: "Rancho-San-Miguel",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rancho San Miguel",
  },
  {
    display_name_in_ui: "Rarebreed-Veterinary-Partners-Inc-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Rarebreed Veterinary Partners Inc - US",
  },
  {
    display_name_in_ui: "Rarebreed-Veterinary-Partners-Inc-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Rarebreed Veterinary Partners Inc - US",
  },
  {
    display_name_in_ui: "Rawhide",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Rawhide",
  },
  {
    display_name_in_ui: "Rayford-Animal-Wellness-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rayford Animal Wellness Clinic",
  },
  {
    display_name_in_ui: "Reagan-Equine-Mobile-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Reagan Equine Mobile Veterinary Services",
  },
  {
    display_name_in_ui: "Reata-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Reata Equine Hospital",
  },
  {
    display_name_in_ui: "Rederox",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-100mg-30-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 100mg 30 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-100mg-90-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 100mg 90 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-12mg-30-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 12mg 30 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-12mg-90-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 12mg 90 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-25mg-30-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 25mg 30 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-25mg-90-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 25mg 90 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-75mg-30-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 75mg 30 ct",
  },
  {
    display_name_in_ui: "Rederox-deracoxib-Chewable-Tablets-75mg-90-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox (deracoxib) Chewable Tablets 75mg 90 ct",
  },
  {
    display_name_in_ui: "Rederox-Chewable-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Rederox Chewable Tablets",
  },
  {
    display_name_in_ui: "Redonyl",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Redonyl",
  },
  {
    display_name_in_ui: "Redonyl-Ultra-100mg-Chews-120ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Redonyl Ultra 100mg Chews 120ct",
  },
  {
    display_name_in_ui: "Redonyl-Ultra-Feline-Powder-3-5-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Redonyl Ultra Feline Powder 3.5 oz",
  },
  {
    display_name_in_ui: "Redonyl-Ultra-Powder",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Redonyl Ultra Powder",
  },
  {
    display_name_in_ui: "Redonyl-Ultra-Soft-Chews",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Redonyl Ultra Soft Chews",
  },
  {
    display_name_in_ui: "Redonyl-Ultra-Soft-Chews-200-mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Redonyl Ultra Soft Chews 200 mg",
  },
  {
    display_name_in_ui: "Regulated-Derm",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Regulated Derm",
  },
  {
    display_name_in_ui: "Renee-Wanner-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Renee Wanner DVM",
  },
  {
    display_name_in_ui: "Reproductive",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Reproductive",
  },
  {
    display_name_in_ui: "Retail",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "Retail",
  },
  {
    display_name_in_ui: "Rey-Associates-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rey & Associates Sports Medicine",
  },
  {
    display_name_in_ui: "Rhinebeck-Equine-LLP",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rhinebeck Equine LLP",
  },
  {
    display_name_in_ui: "Ridge-Haven-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ridge Haven Equine",
  },
  {
    display_name_in_ui: "Rio-Colorado-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rio Colorado Veterinary Service",
  },
  {
    display_name_in_ui: "River-Valley-Veterinary-Hospital-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "River Valley Veterinary Hospital Inc",
  },
  {
    display_name_in_ui: "Riverbend-Equine-Veterinary-Services-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Riverbend Equine Veterinary Services, LLC",
  },
  {
    display_name_in_ui: "Riverview-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Riverview Veterinary Clinic",
  },
  {
    display_name_in_ui: "Roaring-Fork-Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Roaring Fork Equine Medical Center",
  },
  {
    display_name_in_ui: "Roche-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Roche Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Rocky-Point-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rocky Point Animal Hospital",
  },
  {
    display_name_in_ui: "Rocky-Top-Vet-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rocky Top Vet Service",
  },
  {
    display_name_in_ui: "Rompun",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Rompun",
  },
  {
    display_name_in_ui: "Rompun-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Rompun Injection",
  },
  {
    display_name_in_ui: "Rompun-Injection-100-mg-ml-50-ml-vials",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Rompun Injection 100 mg/ml 50 ml vials",
  },
  {
    display_name_in_ui: "Rood-Riddle-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rood & Riddle Equine Hospital",
  },
  {
    display_name_in_ui: "Royal-Vista-Southwest-Services-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Royal Vista Southwest Services, Inc",
  },
  {
    display_name_in_ui: "Royalty-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Royalty Veterinary Services",
  },
  {
    display_name_in_ui: "Rudolphi-Vet-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Rudolphi Vet Service",
  },
  {
    display_name_in_ui: "Russell-Equine-Sport-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Russell Equine Sport Medicine",
  },
  {
    display_name_in_ui: "Ruth-V-Sobeck-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Ruth V. Sobeck, DVM",
  },
  {
    display_name_in_ui: "Safeway",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Safeway",
  },
  {
    display_name_in_ui: "Sage-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sage Veterinary Services",
  },
  {
    display_name_in_ui: "Salado-Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Salado Equine Medical Center",
  },
  {
    display_name_in_ui: "San-Dieguito-Equine-Group",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "San Dieguito Equine Group",
  },
  {
    display_name_in_ui: "San-Luis-Rey-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "San Luis Rey Equine Hospital",
  },
  {
    display_name_in_ui: "Santa-Lucia-Farm-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Santa Lucia Farm Inc",
  },
  {
    display_name_in_ui: "Sarah-Birch-Veterinary-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sarah Birch Veterinary Inc",
  },
  {
    display_name_in_ui: "Sault-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sault Animal Hospital",
  },
  {
    display_name_in_ui: "Schaefer-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Schaefer Veterinary Service",
  },
  {
    display_name_in_ui: "Scott-Equine-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Scott Equine Services",
  },
  {
    display_name_in_ui: "Seattle-Equine-Performance",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Seattle Equine Performance",
  },
  {
    display_name_in_ui: "Sedative",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Sedative",
  },
  {
    display_name_in_ui: "Sevoflurane",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Sevoflurane",
  },
  {
    display_name_in_ui: "Sevoflurane-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Sevoflurane",
  },
  {
    display_name_in_ui: "Sevoflurane-250-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Sevoflurane 250 mL",
  },
  {
    display_name_in_ui: "Sharp-Sports-Medicine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sharp Sports Medicine",
  },
  {
    display_name_in_ui: "Signature-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Signature Equine Hospital",
  },
  {
    display_name_in_ui: "Skillman-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Skillman Veterinary Services",
  },
  {
    display_name_in_ui: "Sky-Canyon-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sky Canyon Veterinary Hospital",
  },
  {
    display_name_in_ui: "Small-Animal-Surgical-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Small Animal Surgical Services",
  },
  {
    display_name_in_ui: "Smith-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Smith Equine & Veterinary Services",
  },
  {
    display_name_in_ui: "Smith-Equine-Performance",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Smith Equine Performance",
  },
  {
    display_name_in_ui: "Socal-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Socal Equine Hospital",
  },
  {
    display_name_in_ui: "Solas-Equine-Veterinary",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Solas Equine Veterinary",
  },
  {
    display_name_in_ui: "Solovecin",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Solovecin",
  },
  {
    display_name_in_ui: "Solovecin-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Solovecin",
  },
  {
    display_name_in_ui: "Solovecin-Cefovecin-Sodium-80mg-10mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Solovecin (Cefovecin Sodium) 80mg 10mL",
  },
  {
    display_name_in_ui: "South-Valley-Large-Animal",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "South Valley Large Animal",
  },
  {
    display_name_in_ui: "Southeast-Equine-Veterinary",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Southeast Equine Veterinary",
  },
  {
    display_name_in_ui: "Southern-Equine-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Southern Equine Service",
  },
  {
    display_name_in_ui: "Southlane-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Southlane Veterinary Hospital",
  },
  {
    display_name_in_ui: "Sploot-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Sploot Group",
  },
  {
    display_name_in_ui: "Sploot-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Sploot Group",
  },
  {
    display_name_in_ui: "Sporimune",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Sporimune",
  },
  {
    display_name_in_ui: "Sporimune-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Sporimune",
  },
  {
    display_name_in_ui: "Sporimune-100mg-15ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Sporimune 100mg 15ct",
  },
  {
    display_name_in_ui: "Sporimune-25mg-15ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Sporimune 25mg 15ct",
  },
  {
    display_name_in_ui: "Sporimune-50mg-15ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Sporimune 50mg 15ct",
  },
  {
    display_name_in_ui: "Sports-Medicine-Associates-of-Chester-County",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sports Medicine Associates of Chester County",
  },
  {
    display_name_in_ui: "Spring-Park-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Spring Park Animal Hospital",
  },
  {
    display_name_in_ui: "Stanford-University-Veterinary-Service-Center-VSC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Stanford University - Veterinary Service Center (VSC)",
  },
  {
    display_name_in_ui: "Star-Equine-Vet-Mobile-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Star Equine Vet Mobile Services",
  },
  {
    display_name_in_ui: "Steinbeck-Peninsula-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Steinbeck Peninsula Equine Clinic",
  },
  {
    display_name_in_ui: "Stevens-Equine-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Stevens Equine LLC",
  },
  {
    display_name_in_ui: "SucroMate-Equine",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "SucroMate Equine",
  },
  {
    display_name_in_ui: "SucroMate-Equine-Sterile-Suspension",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "SucroMate Equine Sterile Suspension",
  },
  {
    display_name_in_ui: "SucroMate-Equine-Sterile-Suspension-10ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "SucroMate Equine Sterile Suspension 10ml",
  },
  {
    display_name_in_ui: "SulfaSol-Soluble-Powder-107gm",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "SulfaSol Soluble Powder 107gm",
  },
  {
    display_name_in_ui: "Sulforal",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Sulforal",
  },
  {
    display_name_in_ui: "Sulforal-Solution",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Sulforal Solution",
  },
  {
    display_name_in_ui: "Sulforal-Solution-1-gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Sulforal Solution 1 gal",
  },
  {
    display_name_in_ui: "Summit-Equine-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Summit Equine Inc",
  },
  {
    display_name_in_ui: "Sun-Coast-Equine-Veterinary-Care",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sun Coast Equine Veterinary Care",
  },
  {
    display_name_in_ui: "Sundance-Large-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Sundance Large Animal Hospital",
  },
  {
    display_name_in_ui: "Superior-Performance-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Superior Performance Equine Clinic",
  },
  {
    display_name_in_ui: "Supplement",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Supplement",
  },
  {
    display_name_in_ui: "Surgical-Referral-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Surgical Referral Service",
  },
  {
    display_name_in_ui: "Suveto-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Suveto - US",
  },
  {
    display_name_in_ui: "Suveto-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Suveto - US",
  },
  {
    display_name_in_ui: "Suzanne-Brenner-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Suzanne Brenner DVM",
  },
  {
    display_name_in_ui: "SynergyVet-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "SynergyVet Group",
  },
  {
    display_name_in_ui: "SynergyVet-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "SynergyVet Group",
  },
  {
    display_name_in_ui: "TAG-Veterinary-Support-Services-LLC",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "TAG Veterinary Support Services, LLC",
  },
  {
    display_name_in_ui: "TAG-Veterinary-Support-Services-LLC-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "TAG Veterinary Support Services, LLC",
  },
  {
    display_name_in_ui: "Tanner-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Tanner Equine",
  },
  {
    display_name_in_ui: "Tec-3-Isoflurane-Vaporizer",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Tec 3 Isoflurane Vaporizer",
  },
  {
    display_name_in_ui: "Tec-3-Isoflurane-Vaporizer-1",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Tec 3 Isoflurane Vaporizer",
  },
  {
    display_name_in_ui: "Tec-3-Sevoflurane-Vaporizer",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Tec 3 Sevoflurane Vaporizer",
  },
  {
    display_name_in_ui: "Tec-3-Sevoflurane-Vaporizer-1",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Tec 3 Sevoflurane Vaporizer",
  },
  {
    display_name_in_ui: "Tennessee-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Tennessee Equine Hospital",
  },
  {
    display_name_in_ui: "Tetrasol",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Tetrasol",
  },
  {
    display_name_in_ui: "Tetrasol-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Tetrasol",
  },
  {
    display_name_in_ui: "Tetrasol-Soluble-Powder-5-lb-Pails",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Tetrasol Soluble Powder 5 lb Pails",
  },
  {
    display_name_in_ui: "Texas-A-M-University",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Texas A&M University",
  },
  {
    display_name_in_ui: "Texas-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Texas Equine Hospital",
  },
  {
    display_name_in_ui: "Thames-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Thames Veterinary Service",
  },
  {
    display_name_in_ui: "The-Curators-of-the-University-of-Missouri",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "The Curators of the University of Missouri",
  },
  {
    display_name_in_ui: "The-Equine-Clinic-At-Oakencroft",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "The Equine Clinic At Oakencroft",
  },
  {
    display_name_in_ui: "The-Marine-Mammal-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "The Marine Mammal Center",
  },
  {
    display_name_in_ui: "The-Pony-Express-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "The Pony Express Veterinary Hospital",
  },
  {
    display_name_in_ui: "The-Veterinary-Group-LLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "The Veterinary Group LLC",
  },
  {
    display_name_in_ui: "Thomas-Hansen-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Thomas Hansen DVM",
  },
  {
    display_name_in_ui: "Thrive-Pet-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Thrive Pet - US",
  },
  {
    display_name_in_ui: "Thunder-Equine-Sports-Medicine-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Thunder Equine Sports Medicine PLLC",
  },
  {
    display_name_in_ui: "Tillema-Veterinary-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Tillema Veterinary Clinic",
  },
  {
    display_name_in_ui: "Tilzolan-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Tilzolan Injection",
  },
  {
    display_name_in_ui: "Timber-Creek-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Timber Creek Veterinary Hospital",
  },
  {
    display_name_in_ui: "Torphadine",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Torphadine",
  },
  {
    display_name_in_ui: "Torphadine-10ml-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Torphadine 10ml vial",
  },
  {
    display_name_in_ui: "Torphadine-50ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Torphadine 50ml",
  },
  {
    display_name_in_ui: "Torphadine-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Torphadine Injection",
  },
  {
    display_name_in_ui: "Tractor-Supply",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Tractor Supply",
  },
  {
    display_name_in_ui: "Triz-Ultra-Keto-12oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Triz Ultra + Keto 12oz",
  },
  {
    display_name_in_ui: "Triz-Ultra-Keto-4oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Triz Ultra + Keto 4oz",
  },
  {
    display_name_in_ui: "TrizChlor",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor",
  },
  {
    display_name_in_ui: "TrizCHLOR-4-Mousse-7-1oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizCHLOR 4 Mousse 7.1oz",
  },
  {
    display_name_in_ui: "TrizChlor-4-Shampoo-16oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor 4 Shampoo 16oz",
  },
  {
    display_name_in_ui: "TrizChlor-4-Shampoo-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor 4 Shampoo 8oz",
  },
  {
    display_name_in_ui: "TrizChlor-4-Shampoo-Gal",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor 4 Shampoo Gal",
  },
  {
    display_name_in_ui: "TrizChlor-4-Spray-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor 4 Spray 8oz",
  },
  {
    display_name_in_ui: "Trizchlor-4-Spray-8ozBF",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Trizchlor 4 Spray 8ozBF",
  },
  {
    display_name_in_ui: "TrizChlor-4-Wipes-50bx",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor 4 Wipes 50bx",
  },
  {
    display_name_in_ui: "TrizChlor-4HC-Spray-8oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor 4HC Spray 8oz",
  },
  {
    display_name_in_ui: "TrizChlor-Flush",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor Flush",
  },
  {
    display_name_in_ui: "TrizChlor-Flush-4oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor Flush 4oz",
  },
  {
    display_name_in_ui: "TrizChlor-Mousse",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor Mousse",
  },
  {
    display_name_in_ui: "TrizChlor-Shampoo",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor Shampoo",
  },
  {
    display_name_in_ui: "TrizChlor-Spray-Conditioner",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor Spray/Conditioner",
  },
  {
    display_name_in_ui: "TrizChlor-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizChlor Wipes",
  },
  {
    display_name_in_ui: "TrizEDTA",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "TrizEDTA",
  },
  {
    display_name_in_ui: "TrizEdta-Aqueous-Flush-16oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizEdta Aqueous Flush 16oz",
  },
  {
    display_name_in_ui: "TrizEdta-Aqueous-Flush-4oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "TrizEdta Aqueous Flush 4oz",
  },
  {
    display_name_in_ui: "TrizEDTA-Flush",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizEDTA Flush",
  },
  {
    display_name_in_ui: "TrizUltra",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "TrizUltra",
  },
  {
    display_name_in_ui: "TrizUltra-Flush",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "TrizUltra Flush",
  },
  {
    display_name_in_ui: "Trolley-Cart",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Trolley Cart",
  },
  {
    display_name_in_ui: "Tropicana-Animal-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Tropicana Animal Hospital",
  },
  {
    display_name_in_ui: "Tropicana-Group-Parent",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Tropicana Group - Parent",
  },
  {
    display_name_in_ui: "Tropicana-Group-Parent-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Tropicana Group - Parent",
  },
  {
    display_name_in_ui: "TruRx",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "TruRx",
  },
  {
    display_name_in_ui: "Tryon-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Tryon Equine Hospital",
  },
  {
    display_name_in_ui: "Tulsa-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Tulsa Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Tzed",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Tzed",
  },
  {
    display_name_in_ui: "Tzed-Injectable-100mg-mL-5mL-Vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Tzed Injectable 100mg/mL 5mL Vial",
  },
  {
    display_name_in_ui: "Unaligned",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "Unaligned",
  },
  {
    display_name_in_ui: "Unaligned-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Unaligned",
  },
  {
    display_name_in_ui: "University",
    field_name: "channel",
    table_name: "",
    schema_name: "",
    entity_name: "University",
  },
  {
    display_name_in_ui: "University-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "University",
  },
  {
    display_name_in_ui: "University-of-California-Davis-VMTH-Pharmacy",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "University of California - Davis VMTH Pharmacy",
  },
  {
    display_name_in_ui: "University-of-Florida-Veterinary-Hospitals",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "University of Florida Veterinary Hospitals",
  },
  {
    display_name_in_ui: "University-of-Georgia",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "University of Georgia",
  },
  {
    display_name_in_ui: "University-of-Minnesota-Veterinary-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "University of Minnesota Veterinary Medical Center",
  },
  {
    display_name_in_ui: "University-of-Penn-New-Bolton-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "University of Penn New Bolton Center",
  },
  {
    display_name_in_ui: "University-of-Tennessee-VMC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "University of Tennessee VMC",
  },
  {
    display_name_in_ui: "Upstate-Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Upstate Equine Medical Center",
  },
  {
    display_name_in_ui: "UVC-Vitality-Group-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "UVC/Vitality Group - US",
  },
  {
    display_name_in_ui: "UVC-Vitality-Group-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "UVC/Vitality Group - US",
  },
  {
    display_name_in_ui: "Valley-Vet-Supply",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Valley Vet Supply",
  },
  {
    display_name_in_ui: "Vaporizer",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Vaporizer",
  },
  {
    display_name_in_ui: "Vaquero-Animal-Health",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vaquero Animal Health",
  },
  {
    display_name_in_ui: "VCA-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "VCA - US",
  },
  {
    display_name_in_ui: "VEDCO-Incorporated",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "VEDCO Incorporated",
  },
  {
    display_name_in_ui: "Veritas-Group",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Veritas Group",
  },
  {
    display_name_in_ui: "Veritas-Group-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Veritas Group",
  },
  {
    display_name_in_ui: "Vermont-Large-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vermont Large Animal Clinic",
  },
  {
    display_name_in_ui: "Vet-Med-Center-of-Hardeeville",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vet Med Center of Hardeeville",
  },
  {
    display_name_in_ui: "Vet-RX-Direct",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Vet RX Direct",
  },
  {
    display_name_in_ui: "Vetcor",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vetcor",
  },
  {
    display_name_in_ui: "VetCor-Corp-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "VetCor Corp - US",
  },
  {
    display_name_in_ui: "Vetcor-US",
    field_name: "master_corporate_group",
    table_name: "",
    schema_name: "",
    entity_name: "Vetcor US",
  },
  {
    display_name_in_ui: "Vetcor-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Vetcor US",
  },
  {
    display_name_in_ui: "Veterinary-Emergency-Group-VEG-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Emergency Group (VEG) - US",
  },
  {
    display_name_in_ui: "Veterinary-Emergency-Group-VEG-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Emergency Group (VEG) - US",
  },
  {
    display_name_in_ui: "Veterinary-Health-Center-at-Kansas-State",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Health Center at Kansas State",
  },
  {
    display_name_in_ui: "Veterinary-Innovative-Partners-VIP",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Innovative Partners (VIP)",
  },
  {
    display_name_in_ui: "Veterinary-Innovative-Partners-VIP-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Innovative Partners (VIP)",
  },
  {
    display_name_in_ui: "Veterinary-Practice-Partners-VPP-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Practice Partners (VPP) - US",
  },
  {
    display_name_in_ui: "Veterinary-Practice-Partners-VPP-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Practice Partners (VPP) - US",
  },
  {
    display_name_in_ui: "Veterinary-Reproduction-Innovations",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Veterinary Reproduction Innovations",
  },
  {
    display_name_in_ui: "VetEvolve",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "VetEvolve",
  },
  {
    display_name_in_ui: "vetevolve",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "vetevolve",
  },
  {
    display_name_in_ui: "VETIVEX",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "VETIVEX",
  },
  {
    display_name_in_ui: "Vetivex-0-9-Sodium-Chloride-1000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex 0.9% Sodium Chloride 1000 mL",
  },
  {
    display_name_in_ui: "Vetivex-0-9-Sodium-Chloride-250-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex 0.9% Sodium Chloride 250 mL",
  },
  {
    display_name_in_ui: "Vetivex-0-9-Sodium-Chloride-3000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex 0.9% Sodium Chloride 3000 mL",
  },
  {
    display_name_in_ui: "Vetivex-0-9-Sodium-Chloride-500-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex 0.9% Sodium Chloride 500 mL",
  },
  {
    display_name_in_ui: "Vetivex-Hartmann-s-3000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Hartmann's 3000 mL",
  },
  {
    display_name_in_ui: "VETIVEX-Hartmann-s-Solution",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "VETIVEX Hartmann's Solution",
  },
  {
    display_name_in_ui: "Vetivex-Hartmann-s-Solution-5000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Hartmann's Solution 5000 mL",
  },
  {
    display_name_in_ui: "Vetivex-Hypertonic-Saline-Solution-7-2-1000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Hypertonic Saline Solution 7.2% 1000 mL",
  },
  {
    display_name_in_ui: "VETIVEX-Lactated-Ringers",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "VETIVEX Lactated Ringers",
  },
  {
    display_name_in_ui: "Vetivex-Lactated-Ringers-1000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Lactated Ringers 1000 mL",
  },
  {
    display_name_in_ui: "Vetivex-Lactated-Ringers-250mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Lactated Ringers 250mL",
  },
  {
    display_name_in_ui: "Vetivex-Lactated-Ringers-500-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Lactated Ringers 500 mL",
  },
  {
    display_name_in_ui: "Vetivex-Lactated-Ringers-5000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Lactated Ringers 5000 mL",
  },
  {
    display_name_in_ui: "Vetivex-Lactated-Ringers-and-5-Dextrose-1000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex Lactated Ringers and 5% Dextrose 1000 mL",
  },
  {
    display_name_in_ui: "VETIVEX-Lactated-Ringers-w-Dex",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "VETIVEX Lactated Ringers w Dex",
  },
  {
    display_name_in_ui: "VETIVEX-pHyLyte",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "VETIVEX pHyLyte",
  },
  {
    display_name_in_ui: "Vetivex-pHyLyte-1000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex pHyLyte 1000 mL",
  },
  {
    display_name_in_ui: "Vetivex-pHyLyte-3000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex pHyLyte 3000 mL",
  },
  {
    display_name_in_ui: "Vetivex-pHyLyte-5000-mL",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetivex pHyLyte 5000 mL",
  },
  {
    display_name_in_ui: "VETIVEX-Sodium-Chloride",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "VETIVEX Sodium Chloride",
  },
  {
    display_name_in_ui: "VetMarket-LTD",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "VetMarket LTD",
  },
  {
    display_name_in_ui: "Vetoquinol-USA",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoquinol USA",
  },
  {
    display_name_in_ui: "Vetoryl",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl",
  },
  {
    display_name_in_ui: "Vetoryl-10mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl 10mg",
  },
  {
    display_name_in_ui: "Vetoryl-120mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl 120mg",
  },
  {
    display_name_in_ui: "Vetoryl-20mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl 20mg",
  },
  {
    display_name_in_ui: "Vetoryl-30mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl 30mg",
  },
  {
    display_name_in_ui: "Vetoryl-5mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl 5mg",
  },
  {
    display_name_in_ui: "Vetoryl-60mg",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl 60mg",
  },
  {
    display_name_in_ui: "Vetoryl-Capsules",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetoryl Capsules",
  },
  {
    display_name_in_ui: "Vetradent",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent",
  },
  {
    display_name_in_ui: "Vetradent-Dental-Spray",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Dental Spray",
  },
  {
    display_name_in_ui: "Vetradent-Dental-Spray-2-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Dental Spray 2 oz",
  },
  {
    display_name_in_ui: "Vetradent-Dental-Wipes",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Dental Wipes",
  },
  {
    display_name_in_ui: "Vetradent-Dental-Wipes-60-pack",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Dental Wipes 60 pack",
  },
  {
    display_name_in_ui: "Vetradent-Oral-Care-Powder-300g",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Oral Care Powder 300g",
  },
  {
    display_name_in_ui: "Vetradent-Rawhide-Chews",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Rawhide Chews",
  },
  {
    display_name_in_ui: "Vetradent-Rawhide-Dental-Chews-for-Dogs-Large-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Rawhide Dental Chews for Dogs (Large) 30ct",
  },
  {
    display_name_in_ui: "Vetradent-Rawhide-Dental-Chews-for-Dogs-Medium-30ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Rawhide Dental Chews for Dogs (Medium) 30ct",
  },
  {
    display_name_in_ui: "Vetradent-Toothpaste",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Toothpaste",
  },
  {
    display_name_in_ui: "Vetradent-Toothpaste-for-Dogs-Cats-2-3-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Toothpaste for Dogs & Cats 2.3 oz",
  },
  {
    display_name_in_ui: "Vetradent-Veggie-Chews",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Veggie Chews",
  },
  {
    display_name_in_ui: "Vetradent-Veggie-Chews-Large",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Veggie Chews - Large",
  },
  {
    display_name_in_ui: "Vetradent-Veggie-Chews-Medium",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Veggie Chews - Medium",
  },
  {
    display_name_in_ui: "Vetradent-Veggie-Chews-Small",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Veggie Chews - Small",
  },
  {
    display_name_in_ui: "Vetradent-Water-Additive",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Water Additive",
  },
  {
    display_name_in_ui: "Vetradent-Water-Additive-17-oz",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Vetradent Water Additive 17 oz",
  },
  {
    display_name_in_ui: "Vetropolycin",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Vetropolycin",
  },
  {
    display_name_in_ui: "Vetropolycin-Ointment",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Vetropolycin Ointment",
  },
  {
    display_name_in_ui: "Vets-Pets-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Vets Pets - US",
  },
  {
    display_name_in_ui: "Vets-Pets-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Vets Pets - US",
  },
  {
    display_name_in_ui: "VetSource-Home-Delivery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "VetSource Home Delivery",
  },
  {
    display_name_in_ui: "Victor-Medical-Company",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Victor Medical Company",
  },
  {
    display_name_in_ui: "Virginia-Equine-Imaging",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Virginia Equine Imaging",
  },
  {
    display_name_in_ui: "Virginia-Polytechnic-Institute-and-State-University",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Virginia Polytechnic Institute and State University",
  },
  {
    display_name_in_ui: "Vista-Equine-Colorado",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vista Equine Colorado",
  },
  {
    display_name_in_ui: "Vizion-Equine-Sports-Medicine-and-Surgery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Vizion Equine Sports  Medicine and Surgery",
  },
  {
    display_name_in_ui: "Voliva-Equine-LLC-COLLECTIONS",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Voliva Equine LLC - COLLECTIONS",
  },
  {
    display_name_in_ui: "Wagg",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Wagg",
  },
  {
    display_name_in_ui: "Waller-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Waller Equine Hospital",
  },
  {
    display_name_in_ui: "Walmart",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Walmart",
  },
  {
    display_name_in_ui: "Walnut-Valley-Animal-Hospital-COLLECTIONS",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Walnut Valley Animal Hospital - COLLECTIONS",
  },
  {
    display_name_in_ui: "Washington-State-University",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Washington State University",
  },
  {
    display_name_in_ui: "Weatherford-Equine-Medical-Center",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Weatherford Equine Medical Center",
  },
  {
    display_name_in_ui: "Weems-Stephens-Equine-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Weems & Stephens Equine Hospital",
  },
  {
    display_name_in_ui: "Weight-Management",
    field_name: "product_category",
    table_name: "",
    schema_name: "",
    entity_name: "Weight Management",
  },
  {
    display_name_in_ui: "Wellhaven-US",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "Wellhaven - US",
  },
  {
    display_name_in_ui: "Wellhaven-US-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "Wellhaven - US",
  },
  {
    display_name_in_ui: "Wendee-McGuffee-DVM",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Wendee McGuffee, DVM",
  },
  {
    display_name_in_ui: "West-Coast-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "West Coast Equine",
  },
  {
    display_name_in_ui: "West-Texas-Equine-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "West Texas Equine Clinic",
  },
  {
    display_name_in_ui: "Weston-Davis-Equine-Surgery",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Weston Davis Equine Surgery",
  },
  {
    display_name_in_ui: "Wexler-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Wexler Equine",
  },
  {
    display_name_in_ui: "Whispering-Pines-Animal-Care",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Whispering Pines Animal Care",
  },
  {
    display_name_in_ui: "White-Equine-Veterinary-Service",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "White Equine Veterinary Service",
  },
  {
    display_name_in_ui: "Wildlife-Veterinary-Supplies",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Wildlife & Veterinary Supplies",
  },
  {
    display_name_in_ui: "Willamette-Valley-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Willamette Valley Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Willow-Oak-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Willow Oak Equine",
  },
  {
    display_name_in_ui: "Wilson-Veterinary-Hospital",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Wilson Veterinary Hospital",
  },
  {
    display_name_in_ui: "Winners-Circle-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Winners Circle Equine Veterinary Services",
  },
  {
    display_name_in_ui: "Wisconsin-Equine-Clinic-Inc",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Wisconsin Equine Clinic, Inc",
  },
  {
    display_name_in_ui: "Woodforest-Vet-PLLC",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Woodforest Vet, PLLC",
  },
  {
    display_name_in_ui: "Woodland-Run-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Woodland Run Equine",
  },
  {
    display_name_in_ui: "Woods-End-Equine-Veterinary-Services",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Woods End Equine Veterinary Services",
  },
  {
    display_name_in_ui: "WVP-WESTERN-VETERINARY-PARTNERS-GROUP",
    field_name: "corporate_account_group",
    table_name: "",
    schema_name: "",
    entity_name: "WVP WESTERN VETERINARY PARTNERS GROUP",
  },
  {
    display_name_in_ui: "WVP-WESTERN-VETERINARY-PARTNERS-GROUP-1",
    field_name: "subchannel",
    table_name: "",
    schema_name: "",
    entity_name: "WVP WESTERN VETERINARY PARTNERS GROUP",
  },
  {
    display_name_in_ui: "York-Animal-Clinic",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "York Animal Clinic",
  },
  {
    display_name_in_ui: "Youngblood-Equine",
    field_name: "customer",
    table_name: "",
    schema_name: "",
    entity_name: "Youngblood Equine",
  },
  {
    display_name_in_ui: "Zenalpha",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Zenalpha",
  },
  {
    display_name_in_ui: "Zenalpha-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Zenalpha",
  },
  {
    display_name_in_ui: "Zenalpha-10-ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Zenalpha 10 ml",
  },
  {
    display_name_in_ui: "Zimeta",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Zimeta",
  },
  {
    display_name_in_ui: "Zimeta-Inj-500mg-ml-100ml-vial",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Zimeta Inj 500mg/ml 100ml vial",
  },
  {
    display_name_in_ui: "Zimeta-Injection",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Zimeta Injection",
  },
  {
    display_name_in_ui: "Zycortal",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Zycortal",
  },
  {
    display_name_in_ui: "Zycortal-Suspension",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Zycortal Suspension",
  },
  {
    display_name_in_ui: "Zycortal-Suspension-4ml",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Zycortal Suspension 4ml",
  },
  {
    display_name_in_ui: "Zycosan",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Zycosan",
  },
  {
    display_name_in_ui: "Zycosan-1",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Zycosan",
  },
  {
    display_name_in_ui: "Zycosan-7-5ml-vial-4-ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Zycosan 7.5ml vial 4 ct",
  },
  {
    display_name_in_ui: "Zygolide",
    field_name: "product_subcategory",
    table_name: "",
    schema_name: "",
    entity_name: "Zygolide",
  },
  {
    display_name_in_ui: "Zygolide-Tablets",
    field_name: "product_family",
    table_name: "",
    schema_name: "",
    entity_name: "Zygolide Tablets",
  },
  {
    display_name_in_ui: "Zygolide-pergolide-tablets-1mg-160ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Zygolide® (pergolide tablets) 1mg 160ct",
  },
  {
    display_name_in_ui: "Zygolide-pergolide-tablets-1mg-60ct",
    field_name: "consolidated_product_description",
    table_name: "",
    schema_name: "",
    entity_name: "Zygolide® (pergolide tablets) 1mg 60ct",
  },
];

export const productHierarchyLookup = [
  {
    display_name_in_ui: "100-Juice",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "100% Juice",
  },
  {
    display_name_in_ui: "16-9-fl-oz-Bottle",
    field_name: "size ",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Active-Nutrition-Group",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Active Nutrition Group",
  },
  {
    display_name_in_ui: "AmeriBeverages-Inc",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriBeverages Inc.",
  },
  {
    display_name_in_ui: "AmeriCola",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola",
  },
  {
    display_name_in_ui:
      "AmeriCola-Berry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola Berry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "AmeriCola-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "AmeriCola-Cherry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola Cherry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "AmeriCola-Citrus-Blend-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "AmeriCola Citrus Blend Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "AmeriCola-Grape-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola Grape Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "AmeriCola-Lemon-Lime-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "AmeriCola Lemon-Lime Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "AmeriCola-Orange-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola Orange Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "AmeriCola-Vanilla-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AmeriCola Vanilla Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Apple",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Apple",
  },
  {
    display_name_in_ui: "AquaEssence",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence",
  },
  {
    display_name_in_ui: "AquaEssence-Blackberry-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence Blackberry Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "AquaEssence-Cucumber-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence Cucumber Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "AquaEssence-Lemon-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence Lemon Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "AquaEssence-Lime-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence Lime Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "AquaEssence-Peach-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence Peach Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "AquaEssence-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "AquaEssence Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Berry",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Berry",
  },
  {
    display_name_in_ui: "Berry-Blast",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Berry Blast",
  },
  {
    display_name_in_ui: "Black",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Black",
  },
  {
    display_name_in_ui: "Black-Tea",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Black Tea",
  },
  {
    display_name_in_ui: "Blackberry",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Blackberry",
  },
  {
    display_name_in_ui: "BoltFuel",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BoltFuel",
  },
  {
    display_name_in_ui:
      "BoltFuel-Berry-Sugar-Free-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BoltFuel Berry Sugar Free Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BoltFuel-Citrus-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BoltFuel Citrus Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BoltFuel-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BoltFuel Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BoltFuel-Sugar-Free-Original-Sugar-Free-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "BoltFuel Sugar Free Original Sugar Free Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BoltFuel-Tropical-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BoltFuel Tropical Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Bottled-Still",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Bottled Still",
  },
  {
    display_name_in_ui: "BrewJoy",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrewJoy",
  },
  {
    display_name_in_ui: "BrewJoy-Black-Tea-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrewJoy Black Tea Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BrewJoy-Green-Tea-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrewJoy Green Tea Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BrewJoy-Lemon-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrewJoy Lemon Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BrewJoy-Peach-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrewJoy Peach Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BrewJoy-Raspberry-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrewJoy Raspberry Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Bright-Brands-Co",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Bright Brands Co.",
  },
  {
    display_name_in_ui: "BrightFizz",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz",
  },
  {
    display_name_in_ui:
      "BrightFizz-Berry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz Berry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "BrightFizz-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BrightFizz-Cherry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz Cherry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BrightFizz-Citrus-Blend-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "BrightFizz Citrus Blend Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BrightFizz-Grape-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz Grape Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BrightFizz-Lemon-Lime-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "BrightFizz Lemon-Lime Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BrightFizz-Orange-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz Orange Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "BrightFizz-Vanilla-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "BrightFizz Vanilla Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Caramel",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Caramel",
  },
  {
    display_name_in_ui: "Carbonated-Soft-Drinks",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Carbonated Soft Drinks",
  },
  {
    display_name_in_ui: "Cherry",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Cherry",
  },
  {
    display_name_in_ui: "Citrus",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Citrus",
  },
  {
    display_name_in_ui: "Citrus-Blend",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Citrus Blend",
  },
  {
    display_name_in_ui: "Coffee",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Coffee",
  },
  {
    display_name_in_ui: "Cola",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Cola",
  },
  {
    display_name_in_ui: "ColaMax",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax",
  },
  {
    display_name_in_ui:
      "ColaMax-Berry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Berry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ColaMax-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "ColaMax-Cherry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Cherry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "ColaMax-Citrus-Blend-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "ColaMax Citrus Blend Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "ColaMax-Grape-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Grape Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "ColaMax-Lemon-Lime-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Lemon-Lime Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "ColaMax-Orange-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Orange Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "ColaMax-Vanilla-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ColaMax Vanilla Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Cold-Brew",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Cold Brew",
  },
  {
    display_name_in_ui: "CoolBrew",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CoolBrew",
  },
  {
    display_name_in_ui: "CoolBrew-Black-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CoolBrew Black Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CoolBrew-Caramel-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CoolBrew Caramel Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CoolBrew-Hazelnut-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CoolBrew Hazelnut Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CoolBrew-Mocha-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CoolBrew Mocha Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CoolBrew-Vanilla-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CoolBrew Vanilla Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CrystalSplash",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash",
  },
  {
    display_name_in_ui: "CrystalSplash-Blackberry-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash Blackberry Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CrystalSplash-Cucumber-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash Cucumber Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CrystalSplash-Lemon-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash Lemon Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CrystalSplash-Lime-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash Lime Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CrystalSplash-Peach-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash Peach Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "CrystalSplash-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "CrystalSplash Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Cucumber",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Cucumber",
  },
  {
    display_name_in_ui: "Daily-Grind-Beverages",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Daily Grind Beverages",
  },
  {
    display_name_in_ui: "DailyBean",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "DailyBean",
  },
  {
    display_name_in_ui: "DailyBean-Black-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "DailyBean Black Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "DailyBean-Caramel-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "DailyBean Caramel Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "DailyBean-Hazelnut-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "DailyBean Hazelnut Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "DailyBean-Mocha-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "DailyBean Mocha Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "DailyBean-Vanilla-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "DailyBean Vanilla Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnduroMax",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnduroMax",
  },
  {
    display_name_in_ui:
      "EnduroMax-Berry-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnduroMax Berry Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "EnduroMax-Citrus-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnduroMax Citrus Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnduroMax-Fruit-Punch-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnduroMax Fruit Punch Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnduroMax-Lemon-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnduroMax Lemon Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnduroMax-Orange-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnduroMax Orange Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "EnduroMax-Watermelon-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "EnduroMax Watermelon Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Energy-Drinks",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Energy Drinks",
  },
  {
    display_name_in_ui: "EnergyX",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnergyX",
  },
  {
    display_name_in_ui:
      "EnergyX-Berry-Sugar-Free-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnergyX Berry Sugar Free Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnergyX-Citrus-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnergyX Citrus Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnergyX-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnergyX Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "EnergyX-Sugar-Free-Original-Sugar-Free-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "EnergyX Sugar Free Original Sugar Free Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "EnergyX-Tropical-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "EnergyX Tropical Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FizzUp",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp",
  },
  {
    display_name_in_ui: "FizzUp-Berry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Berry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FizzUp-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "FizzUp-Cherry-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Cherry Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "FizzUp-Citrus-Blend-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Citrus Blend Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FizzUp-Grape-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Grape Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "FizzUp-Lemon-Lime-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Lemon-Lime Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "FizzUp-Orange-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Orange Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "FizzUp-Vanilla-Carbonated-Soft-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FizzUp Vanilla Carbonated Soft Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Flavored-Carbonates",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Flavored Carbonates",
  },
  {
    display_name_in_ui: "Fresh-Farms-Co",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Fresh Farms Co.",
  },
  {
    display_name_in_ui: "Fruit-Punch",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Fruit Punch",
  },
  {
    display_name_in_ui: "FruitWave",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave",
  },
  {
    display_name_in_ui: "FruitWave-Apple-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave Apple Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FruitWave-Berry-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave Berry Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FruitWave-Fruit-Punch-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave Fruit Punch Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FruitWave-Grape-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave Grape Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FruitWave-Orange-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave Orange Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "FruitWave-Tropical-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "FruitWave Tropical Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Grape",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Grape",
  },
  {
    display_name_in_ui: "Green-Tea",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Green Tea",
  },
  {
    display_name_in_ui: "Hazelnut",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Hazelnut",
  },
  {
    display_name_in_ui: "HydraPure",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure",
  },
  {
    display_name_in_ui: "HydraPure-Blackberry-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure Blackberry Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "HydraPure-Cucumber-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure Cucumber Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "HydraPure-Lemon-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure Lemon Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "HydraPure-Lime-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure Lime Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "HydraPure-Peach-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure Peach Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "HydraPure-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "HydraPure Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Iced-Coffee",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Iced Coffee",
  },
  {
    display_name_in_ui: "Isotonic",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Isotonic",
  },
  {
    display_name_in_ui: "JavaRush",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JavaRush",
  },
  {
    display_name_in_ui: "JavaRush-Black-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JavaRush Black Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JavaRush-Caramel-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JavaRush Caramel Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JavaRush-Hazelnut-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JavaRush Hazelnut Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JavaRush-Mocha-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JavaRush Mocha Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JavaRush-Vanilla-Coffee-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JavaRush Vanilla Coffee 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Juice",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Juice",
  },
  {
    display_name_in_ui: "Juice-Drinks",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Juice Drinks",
  },
  {
    display_name_in_ui: "JuicyBurst",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst",
  },
  {
    display_name_in_ui: "JuicyBurst-Apple-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst Apple Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JuicyBurst-Berry-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst Berry Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JuicyBurst-Fruit-Punch-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst Fruit Punch Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JuicyBurst-Grape-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst Grape Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JuicyBurst-Orange-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst Orange Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "JuicyBurst-Tropical-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "JuicyBurst Tropical Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Lemon",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Lemon",
  },
  {
    display_name_in_ui: "Lemon-Lime",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Lemon-Lime",
  },
  {
    display_name_in_ui: "Lemon-Lime-Soda",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Lemon-Lime Soda",
  },
  {
    display_name_in_ui: "Lime",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Lime",
  },
  {
    display_name_in_ui: "Low-Calorie",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Low Calorie",
  },
  {
    display_name_in_ui: "Mocha",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Mocha",
  },
  {
    display_name_in_ui: "Natural-Squeeze",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze",
  },
  {
    display_name_in_ui: "Natural-Squeeze-Apple-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze Apple Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Natural-Squeeze-Berry-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze Berry Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Natural-Squeeze-Fruit-Punch-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze Fruit Punch Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Natural-Squeeze-Grape-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze Grape Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Natural-Squeeze-Orange-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze Orange Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Natural-Squeeze-Tropical-Juice-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Natural Squeeze Tropical Juice 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "NitroRush",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "NitroRush",
  },
  {
    display_name_in_ui:
      "NitroRush-Berry-Sugar-Free-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "NitroRush Berry Sugar Free Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "NitroRush-Citrus-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "NitroRush Citrus Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "NitroRush-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "NitroRush Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "NitroRush-Sugar-Free-Original-Sugar-Free-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "NitroRush Sugar Free Original Sugar Free Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "NitroRush-Tropical-Energy-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "NitroRush Tropical Energy Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Orange",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Orange",
  },
  {
    display_name_in_ui: "Original",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Original",
  },
  {
    display_name_in_ui: "Peach",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Peach",
  },
  {
    display_name_in_ui: "PowerFuel-Corp",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerFuel Corp.",
  },
  {
    display_name_in_ui: "PowerRush",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerRush",
  },
  {
    display_name_in_ui:
      "PowerRush-Berry-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerRush Berry Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "PowerRush-Citrus-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerRush Citrus Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PowerRush-Fruit-Punch-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerRush Fruit Punch Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PowerRush-Lemon-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerRush Lemon Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PowerRush-Orange-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PowerRush Orange Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "PowerRush-Watermelon-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "PowerRush Watermelon Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PureLeafy",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLeafy",
  },
  {
    display_name_in_ui: "PureLeafy-Black-Tea-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLeafy Black Tea Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PureLeafy-Green-Tea-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLeafy Green Tea Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PureLeafy-Lemon-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLeafy Lemon Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PureLeafy-Peach-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLeafy Peach Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PureLeafy-Raspberry-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLeafy Raspberry Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "PureLife-Beverages",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "PureLife Beverages",
  },
  {
    display_name_in_ui: "Raspberry",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Raspberry",
  },
  {
    display_name_in_ui: "Regular-Energy",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Regular Energy",
  },
  {
    display_name_in_ui: "Sparkling-Water",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Sparkling Water",
  },
  {
    display_name_in_ui: "Sports-Drinks",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Sports Drinks",
  },
  {
    display_name_in_ui: "Sugar-Free-Energy",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Sugar-Free Energy",
  },
  {
    display_name_in_ui: "Sugar-Free-Original",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Sugar-Free Original",
  },
  {
    display_name_in_ui: "Sweetened-Tea",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Sweetened Tea",
  },
  {
    display_name_in_ui: "Tea",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Tea",
  },
  {
    display_name_in_ui: "TeaTime-Brands",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "TeaTime Brands",
  },
  {
    display_name_in_ui: "Thrive-Beverages-LLC",
    field_name: "manufacturer",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Thrive Beverages LLC",
  },
  {
    display_name_in_ui: "ThriveWater",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater",
  },
  {
    display_name_in_ui: "ThriveWater-Blackberry-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater Blackberry Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ThriveWater-Cucumber-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater Cucumber Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ThriveWater-Lemon-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater Lemon Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ThriveWater-Lime-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater Lime Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ThriveWater-Peach-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater Peach Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ThriveWater-Water-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ThriveWater Water 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Tropical",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Tropical",
  },
  {
    display_name_in_ui: "Tropical-Blend",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Tropical Blend",
  },
  {
    display_name_in_ui: "Unflavored",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Unflavored",
  },
  {
    display_name_in_ui: "Unsweetened-Tea",
    field_name: "type",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Unsweetened Tea",
  },
  {
    display_name_in_ui: "Vanilla",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Vanilla",
  },
  {
    display_name_in_ui: "VitaSport",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "VitaSport",
  },
  {
    display_name_in_ui:
      "VitaSport-Berry-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "VitaSport Berry Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "VitaSport-Citrus-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "VitaSport Citrus Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "VitaSport-Fruit-Punch-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "VitaSport Fruit Punch Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "VitaSport-Lemon-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "VitaSport Lemon Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "VitaSport-Orange-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "VitaSport Orange Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui:
      "VitaSport-Watermelon-Low-Calorie-Sports-Drinks-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name:
      "VitaSport Watermelon Low Calorie Sports Drinks 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "Water",
    field_name: "sub_category",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Water",
  },
  {
    display_name_in_ui: "Watermelon",
    field_name: "flavor",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "Watermelon",
  },
  {
    display_name_in_ui: "ZestTea",
    field_name: "brand",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ZestTea",
  },
  {
    display_name_in_ui: "ZestTea-Black-Tea-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ZestTea Black Tea Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ZestTea-Green-Tea-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ZestTea Green Tea Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ZestTea-Lemon-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ZestTea Lemon Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ZestTea-Peach-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ZestTea Peach Tea 16.9 fl oz Bottle",
  },
  {
    display_name_in_ui: "ZestTea-Raspberry-Tea-16-9-fl-oz-Bottle",
    field_name: "product_name",
    table_name: "product_hierarchy_2",
    schema_name: "pos_nielsen_1",
    entity_name: "ZestTea Raspberry Tea 16.9 fl oz Bottle",
  },
];
